import { useState, useEffect, useMemo, useContext } from "react";
import { createPortal } from "react-dom";
import {
  Page,
  Navbar,
  DialogBox,
  PopUp,
  BtnSmallWhite,
  Sidebar,
  BtnSmall,
  BtnSmallDisabled,
  GeneralLoader
} from "../../components";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import * as ROUTES from "../../constant/routes";
import {
  getAllIndividualUsers,
  createOrganization as createNewOrganization,
  getAllOrganisations,
  getAllThirdPartySellers,
  createThirdPartySeller,
  searchUser,
  createIndiviualUser,
  addUser
} from "../../assets/Js/script";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import OrderHistoryHeader from "../../components/OrderHistoryHeader";
import { useAuth } from "../../hooks";
import CopyIco from "../../assets/images/copy.png";
import { AuthContext } from "../../context/auth";

export default function Users() {
  const { user } = useAuth();

  let { search, setSearch } = useContext(AuthContext);


  const [modals, setModals] = useState({
    userDeleted: false,
    addNew: false,
    stepperOrg: false,
    organizationDeleted: false,
    tpsDeleted: false,
    createdSuccessfully: false,
    manuallyCreatedLoader: false,
    searchUser: false,
    newUserAddSuccessfully: false,
    searchUserLoader: false,
    addUserLoader: false,
    individualCreated: false
  });

  const [addNewPhoto, setAddNewPhoto] = useState({ local: false });
  const [orderHistory, setOrderHistory] = useState(false);
  const [typeOfUser, setTypeOfUser] = useState(0);
  const [users, setUsers] = useState({
    individual: [],
    organisations: [],
    thirdPartySellers: []
  });
  const [newOrgData, setNewOrgData] = useState({
    name: "",
    phone_number: "",
    email: "",
    brand_name: "",
    registered_name: "",
    registered_address: "",
    domain: "",
    gst: "",
    website: ""
  });

  const [newTpsData, setNewTpsData] = useState({
    name: "",
    phone_number: "",
    email: "",
    brand_name: "",
    registered_name: "",
    registered_address: "",
    domain: "",
    gst: "",
    website: ""
  });
  const [checkBox, setCheckBox] = useState();
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [renderedStep, setRenderedStep] = useState(false);
  const [searchUserString, setSearchUserString] = useState("");
  const [userArr, setUserArr] = useState([]);

  const [showPassword, setShowPassword] = useState(false);
  const [userType, setUserType] = useState(0);
  const [userSelected, setUserSelected] = useState(null);
  const [renderedUserType, setRenderedUserType] = useState(null);

  function handleChange({ target }) {
    const { value, name } = target;

    setNewOrgData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  }
  function checkCheckBox(e) {
    const checkData = e.target.checked;
    setCheckBox(checkData);
  }

  const notify = (message) => toast(message);

  function handleUserRemove(id) {
    if (userType === 0) {
      setUsers((prevState) => {
        const filtered = prevState.individual.filter((item) => item !== id);
        return { ...prevState, individual: [...filtered] };
      });
      setModals((prevState) => ({ ...prevState, organizationDeleted: true }));
    } else if (userType === 1) {
      setUsers((prevState) => {
        const filtered = prevState.organisations.filter((item) => item !== id);
        return { ...prevState, organisations: [...filtered] };
      });
      setModals((prevState) => ({ ...prevState, userDeleted: true }));
    } else {
      setUsers((prevState) => {
        const filtered = prevState.thirdPartySellers.filter(
          (item) => item !== id
        );
        return { ...prevState, thirdPartySellers: [...filtered] };
      });
      setModals((prevState) => ({ ...prevState, tpsDeleted: true }));
    }
  }
  const {
    register,
    watch,
    handleSubmit,
    reset,
    getValues,
    formState: { errors, isValid }
  } = useForm({ mode: "all" });

  function handleNewOrganization(data) {
    if (data) {
      setNewOrgData((prev) => ({
        ...prev,
        name: data.name,
        phone_number: data.phone_number,
        email: data.email,
        brand_name: data.brand_name,
        registered_name: data.registered_name,
        registered_address: data.registered_address,
        // domain: data.domain,
        gst: data.gst,
        website: data.website
      }));
    }
  }

  useMemo(() => {
    currentStep === 2 && formStepUp();
  }, [newOrgData]);

  function formStepUp(errors) {
    setCurrentStep((curr) => curr + 1);
  }

  async function handleCreateNewUser(e) {
    e.preventDefault();
    setModals((prevState) => ({ ...prevState, manuallyCreatedLoader: true }));
    if (typeOfUser === 1 && newOrgData) {
      setNewOrgData((prev) => ({
        ...prev,
        name: newOrgData.name,
        phone_number: newOrgData.phone_number,
        email: newOrgData.email,
        brand_name: newOrgData.brand_name,
        registered_name: newOrgData.registered_name,
        registered_address: newOrgData.registered_address,
        // domain: newOrgData.domain,
        gst: newOrgData.gst,
        website: newOrgData.website
      }));
      const { response } = await createNewOrganization({
        fullName: newOrgData.name,
        email: newOrgData.email,
        mobile: newOrgData.phone_number,
        brandName: newOrgData.brand_name,
        registeredName: newOrgData.registered_name,
        registeredAddress: newOrgData.registered_address,
        gstIN: newOrgData.gst,
        // domain: newOrgData.domain,
        website: newOrgData.website
      });

      if (response.status === "success") {
        setModals((prevState) => ({
          ...prevState,
          stepperOrg: false,
          createdSuccessfully: true
        }));
        setUsers((prevState) => ({
          ...prevState,
          organisations: [...prevState.organisations, { ...newOrgData }]
        }));
        setNewOrgData({
          name: "",
          phone_number: "",
          email: "",
          brand_name: "",
          registered_name: "",
          registered_address: "",
          // domain: "",
          gst: "",
          website: ""
        });
        setCurrentStep(1);
        organisations();
      } else {
        notify(response?.message ? response?.message : "Something went wrong");
        setCurrentStep(1);
      }
    } else if (typeOfUser === 2) {
      const { response } = await createThirdPartySeller({
        fullName: newOrgData.name,
        email: newOrgData.email,
        mobile: newOrgData.phone_number,
        brandName: newOrgData.brand_name,
        registeredName: newOrgData.registered_name,
        registeredAddress: newOrgData.registered_address,
        gstIN: newOrgData.gst,
        // domain: newOrgData.domain,
        website: newOrgData.website
      });
      if (response.status === "success") {
        setModals((prevState) => ({
          ...prevState,
          stepperOrg: false,
          createdSuccessfully: true
        }));
        setUsers((prevState) => ({
          ...prevState,
          thirdPartySellers: [...prevState.thirdPartySellers, { ...newOrgData }]
        }));
        setNewOrgData({
          name: "",
          phone_number: "",
          email: "",
          brand_name: "",
          registered_name: "",
          registered_address: "",
          // domain: "",
          gst: "",
          website: ""
        });
        setCurrentStep(1);
        thirdPartySeller();
      } else {
        notify(response?.message ? response?.message : "Something went wrong");
        setCurrentStep(1);
      }
    }
    setModals((prevState) => ({ ...prevState, manuallyCreatedLoader: false }));
  }

  const individualUsers = async () => {
    const {
      response: {
        data: { publication }
      }
    } = await getAllIndividualUsers(search);
    console.log(publication,'publication')
    setUsers((prevState) => ({
      ...prevState,
      individual: [publication]
    }));
  };

  const organisations = async () => {
    const { response } = await getAllOrganisations(search);
    setUsers((prevState) => ({
      ...prevState,
      organisations: [response.data]
    }));
  };

  const thirdPartySeller = async () => {
    const { response } = await getAllThirdPartySellers();
    setUsers((prevState) => ({
      ...prevState,
      thirdPartySellers: [response.data]
    }));
  };

  const copyHandler = () => {
    navigator.clipboard.writeText(
      `${process.env.REACT_APP_CUSTOMER_PORTAL_DOMAIN}signup?publication=${user.id}`
    );
    notify("Copied");
  };

  useEffect(() => {
    individualUsers();

    // organisations

    organisations();

    // thirdPartySeller

    thirdPartySeller();
  }, []);

  function getDataOrg(id) {
    if (id) {
      for (var i = 0; i < users.organisations[0].pcpDetail.length; i++) {
        if (users.organisations[0].pcpDetail[i].organisationId == id) {
          return users.organisations[0].pcpDetail[i];
        }
      }
    }
  }
  function getDataTps(id) {
    if (id) {
      for (var i = 0; i < users.thirdPartySellers[0].pcpDetail.length; i++) {
        if (users.thirdPartySellers[0].pcpDetail[i].tpId == id) {
          return users.thirdPartySellers[0].pcpDetail[i];
        }
      }
    }
  }


  console.log(users,'uuuuu')

  useEffect(() => {
    setRenderedUserType(() => {
      switch (userType) {
        case 0:
          return users?.individual[0]?.Customers?.map((item) => (
            <RouterLink
              to={`/users/individual-users/order-history=${item.id}`}
              key={item.id}
              className="w-[501px] h-[182px] select-none relative py-4 px-2 flex border-1 border-solid border-primary-dark-20"
            >
              <div
                className={`w-14 flex items-center justify-center h-14 rounded-full ${
                  item.photo == null && "bg-primary-dark"
                } `}
              >
                {item.photo ? (
                  <img
                    src={`https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/portals/${item.photo}`}
                    alt="img"
                  />
                ) : (
                  <span
                    className={`text-[25px] uppercase font-bold text-[#fff]`}
                  >
                    {item.fullName[0]}
                  </span>
                )}
              </div>
              <div className="ml-4">
                <h4 className="capitalize text-secondary-dark text-montserrat font-semibold text-left m-3 mb-2 ml-0">
                  {item.fullName}
                </h4>
                <div className="flex items-center mb-1">
                  <p className="text-secondary-light mr-[33px] text-[17px] font-[500]">
                    User name:
                  </p>
                  <p className="text-secondary-dark font-semibold">
                    {item.fullName}
                  </p>
                </div>
                <div className="flex items-center mb-1">
                  <p className="text-secondary-light mr-[14px] text-[17px] font-[500]">
                    Email Address:
                  </p>
                  <p className="text-secondary-dark font-semibold">
                    {item.email}
                  </p>
                </div>
                <div className="flex items-center mb-1">
                  <p className="text-secondary-light mr-[14px] text-[17px] font-[500]">
                    Mobile number:
                  </p>
                  <p className="text-secondary-dark font-semibold">
                    +91 {item.mobile}
                  </p>
                </div>
                <div className="flex items-center mb-2">
                  <p className="text-secondary-light mr-[14px] text-[17px] font-[500]">
                    Status:
                  </p>
                  <p
                    className={`font-semibold capitalize ${
                      item.status == "pending"
                        ? "text-[red]"
                        : "text-secondary-dark"
                    }`}
                  >
                    {item.status}
                  </p>
                </div>
              </div>
              {/* <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleUserRemove(item);
                }}
                className="absolute top-8 right-8"
              >
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.61927 9.65676C9.38022 9.87286 9.056 9.99427 8.71794 9.99427C8.37988 9.99427 8.05566 9.87286 7.8166 9.65676L5.00053 6.74689L2.18446 9.6558C2.06645 9.76424 1.92585 9.85049 1.77078 9.90956C1.61572 9.96864 1.44925 9.99937 1.28097 9.99999C1.1127 10.0006 0.945962 9.9711 0.790368 9.91317C0.634774 9.85524 0.493406 9.77003 0.374419 9.66246C0.255433 9.55489 0.161182 9.42709 0.097104 9.28642C0.0330256 9.14575 0.000387576 8.99501 0.00107276 8.84288C0.00175794 8.69075 0.0357526 8.54026 0.101096 8.40007C0.166439 8.25988 0.261838 8.13277 0.38179 8.02608L3.31153 5.00096L0.380728 1.97392C0.260776 1.86723 0.165377 1.74012 0.100034 1.59993C0.0346904 1.45974 0.000695752 1.30925 1.05685e-05 1.15712C-0.000674615 1.00499 0.0319635 0.854247 0.0960419 0.71358C0.16012 0.572914 0.254371 0.445109 0.373357 0.337538C0.492344 0.229967 0.633711 0.144758 0.789306 0.0868277C0.9449 0.0288969 1.11164 -0.000609893 1.27991 9.55452e-06C1.44818 0.000629002 1.61465 0.0313623 1.76972 0.0904366C1.92479 0.149511 2.06538 0.235758 2.1834 0.344201L5.00053 3.25504L7.8166 0.344201C7.93462 0.235758 8.07521 0.149511 8.23028 0.0904366C8.38535 0.0313623 8.55182 0.000629002 8.72009 9.55452e-06C8.88836 -0.000609893 9.0551 0.0288969 9.21069 0.0868277C9.36629 0.144758 9.50766 0.229967 9.62664 0.337538C9.74563 0.445109 9.83988 0.572914 9.90396 0.71358C9.96804 0.854247 10.0007 1.00499 9.99999 1.15712C9.9993 1.30925 9.96531 1.45974 9.89997 1.59993C9.83462 1.74012 9.73922 1.86723 9.61927 1.97392L6.68954 5.00096L9.61927 8.02608C9.73779 8.13311 9.83181 8.26021 9.89596 8.40011C9.96011 8.54001 9.99313 8.68997 9.99313 8.84142C9.99313 8.99287 9.96011 9.14283 9.89596 9.28273C9.83181 9.42263 9.73779 9.54973 9.61927 9.65676Z"
                    fill="black"
                    fill-opacity="0.35"
                  />
                </svg>
              </button> */}
              {modals.userDeleted &&
                createPortal(
                  <DialogBox>
                    <PopUp
                      title="A user has been removed"
                      main="Luke elliot has been removed from your team"
                      body="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eget utvest-ibulum bibendum egestas. Enim mi arcu convallis enim purus interdum. Ut neque at adipiscing tortor facilisis sagittis libero. Ac bibendum vel blandit."
                      button="Back to Users"
                      onClose={() =>
                        setModals((prevState) => ({
                          ...prevState,
                          userDeleted: false
                        }))
                      }
                      onClick={() =>
                        setModals((prevState) => ({
                          ...prevState,
                          userDeleted: false
                        }))
                      }
                    />
                  </DialogBox>,
                  document.body
                )}
            </RouterLink>
          ));

        case 1:
          return users?.organisations[0]?.publication?.Organisations.map(
            (item, index) => (
              <RouterLink
                to={`/users/organisations/order-history=${item.id}`}
                //to={{pathname: `/users/organisations/order-history=${item.id}`, state: {"organization": item}}}
                key={item.id}
                className="w-[501px] h-[168px] relative py-4 px-2 flex border-1 border-solid border-primary-dark-20"
              >
                <div
                  className={`w-14 flex items-center justify-center h-14 rounded-full ${
                    item.organisationPhoto == null && "bg-primary-dark"
                  } `}
                >
                  {item.organisationPhoto ? (
                    <img
                      src={`https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/portals/${item.organisationPhoto}`}
                      alt="img"
                    />
                  ) : (
                    <span
                      className={`text-[25px] uppercase font-bold text-[#fff]`}
                    >
                      {getDataOrg(item.id)?.fullName[0]}
                    </span>
                  )}
                </div>
                <div className="ml-4">
                  <h4 className="capitalize text-ellipsis text-secondary-dark text-montserrat font-semibold text-left m-3 mb-2 ml-0">
                    {getDataOrg(item.id)?.fullName}
                  </h4>
                  <div className="flex items-center mb-1">
                    <p className="text-secondary-light mr-[33px] text-[17px] font-[500]">
                      Registered Name:
                    </p>
                    <p className="text-secondary-dark font-semibold">
                      {item.registeredName}
                    </p>
                  </div>
                  <div className="flex items-center mb-1">
                    <p className="text-secondary-light mr-[14px] text-[17px] font-[500]">
                      Brand Name:
                    </p>
                    <p className="text-secondary-dark font-semibold">
                      {item.brandName}
                    </p>
                  </div>
                  <div className="flex items-center mb-2">
                    <p className="text-secondary-light mr-[14px] text-[17px] font-[500]">
                      GSTIN:
                    </p>
                    <p className="text-secondary-dark uppercase font-semibold">
                      {item.gstIN}
                    </p>
                  </div>
                </div>
                {/* <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleUserRemove(item);
                }}
                className="absolute top-8 right-8"
              >
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.61927 9.65676C9.38022 9.87286 9.056 9.99427 8.71794 9.99427C8.37988 9.99427 8.05566 9.87286 7.8166 9.65676L5.00053 6.74689L2.18446 9.6558C2.06645 9.76424 1.92585 9.85049 1.77078 9.90956C1.61572 9.96864 1.44925 9.99937 1.28097 9.99999C1.1127 10.0006 0.945962 9.9711 0.790368 9.91317C0.634774 9.85524 0.493406 9.77003 0.374419 9.66246C0.255433 9.55489 0.161182 9.42709 0.097104 9.28642C0.0330256 9.14575 0.000387576 8.99501 0.00107276 8.84288C0.00175794 8.69075 0.0357526 8.54026 0.101096 8.40007C0.166439 8.25988 0.261838 8.13277 0.38179 8.02608L3.31153 5.00096L0.380728 1.97392C0.260776 1.86723 0.165377 1.74012 0.100034 1.59993C0.0346904 1.45974 0.000695752 1.30925 1.05685e-05 1.15712C-0.000674615 1.00499 0.0319635 0.854247 0.0960419 0.71358C0.16012 0.572914 0.254371 0.445109 0.373357 0.337538C0.492344 0.229967 0.633711 0.144758 0.789306 0.0868277C0.9449 0.0288969 1.11164 -0.000609893 1.27991 9.55452e-06C1.44818 0.000629002 1.61465 0.0313623 1.76972 0.0904366C1.92479 0.149511 2.06538 0.235758 2.1834 0.344201L5.00053 3.25504L7.8166 0.344201C7.93462 0.235758 8.07521 0.149511 8.23028 0.0904366C8.38535 0.0313623 8.55182 0.000629002 8.72009 9.55452e-06C8.88836 -0.000609893 9.0551 0.0288969 9.21069 0.0868277C9.36629 0.144758 9.50766 0.229967 9.62664 0.337538C9.74563 0.445109 9.83988 0.572914 9.90396 0.71358C9.96804 0.854247 10.0007 1.00499 9.99999 1.15712C9.9993 1.30925 9.96531 1.45974 9.89997 1.59993C9.83462 1.74012 9.73922 1.86723 9.61927 1.97392L6.68954 5.00096L9.61927 8.02608C9.73779 8.13311 9.83181 8.26021 9.89596 8.40011C9.96011 8.54001 9.99313 8.68997 9.99313 8.84142C9.99313 8.99287 9.96011 9.14283 9.89596 9.28273C9.83181 9.42263 9.73779 9.54973 9.61927 9.65676Z"
                    fill="black"
                    fill-opacity="0.35"
                  />
                </svg>
              </button> */}
                {modals.organizationDeleted &&
                  createPortal(
                    <DialogBox>
                      <PopUp
                        title="An organization has been removed"
                        main="Luke elliot has been removed from your team"
                        body="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eget utvest-ibulum bibendum egestas. Enim mi arcu convallis enim purus interdum. Ut neque at adipiscing tortor facilisis sagittis libero. Ac bibendum vel blandit."
                        button="Back to Users"
                        onClose={() =>
                          setModals((prevState) => ({
                            ...prevState,
                            organizationDeleted: false
                          }))
                        }
                        onClick={() =>
                          setModals((prevState) => ({
                            ...prevState,
                            organizationDeleted: false
                          }))
                        }
                      />
                    </DialogBox>,
                    document.body
                  )}
              </RouterLink>
            )
          );

        case 2:
          return users?.thirdPartySellers[0]?.publication?.Tparties?.map(
            (item, i) => (
              <RouterLink
                to={`/users/third-party-sellers/order-history=${item.id}`}
                key={item.id}
                className="w-[501px] h-[168px] relative py-4 px-2 flex border-1 border-solid border-primary-dark-20"
              >
                <div
                  className={`w-14 flex items-center justify-center h-14 rounded-full ${
                    item.thirdPartyPhoto == null && "bg-primary-dark"
                  } `}
                >
                  {item.thirdPartyPhoto ? (
                    <img
                      src={`https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/portals/${item.thirdPartyPhoto}`}
                      alt="img"
                    />
                  ) : (
                    <span
                      className={`text-[25px] uppercase font-bold text-[#fff]`}
                    >
                      {getDataTps(item.id).fullName[0]}
                    </span>
                  )}
                </div>
                <div className="ml-4">
                  <h4 className="capitalize text-ellipsis text-secondary-dark text-montserrat font-semibold text-left m-3 mb-2 ml-0">
                    {getDataTps(item.id).fullName}
                  </h4>
                  <div className="flex items-center mb-1">
                    <p className="text-secondary-light mr-[14px] text-[17px] font-[500]">
                      Registered Name:
                    </p>
                    <p className="text-secondary-dark font-semibold">
                      {item.registeredName}
                    </p>
                  </div>
                  <div className="flex items-center mb-1">
                    <p className="text-secondary-light mr-[47px] text-[17px] font-[500]">
                      Brand name:
                    </p>
                    <p className="text-secondary-dark font-semibold">
                      {item.brandName}
                    </p>
                  </div>
                  {/* <div className="flex items-center mb-1">
                  <p className="text-secondary-light mr-[14px] text-[17px] font-[500]">
                    Email Address:
                  </p>
                  <p className="text-secondary-dark font-semibold">
                    {item.email}
                  </p>
                </div> */}
                  <div className="flex items-center mb-2">
                    <p className="text-secondary-light mr-[14px] text-[17px] font-[500]">
                      GSTIN:
                    </p>
                    <p className=" uppercase text-secondary-dark font-semibold">
                      {item.gstIN}
                    </p>
                  </div>
                </div>
                {/* <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleUserRemove(item);
                }}
                className="absolute top-8 right-8"
              >
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.61927 9.65676C9.38022 9.87286 9.056 9.99427 8.71794 9.99427C8.37988 9.99427 8.05566 9.87286 7.8166 9.65676L5.00053 6.74689L2.18446 9.6558C2.06645 9.76424 1.92585 9.85049 1.77078 9.90956C1.61572 9.96864 1.44925 9.99937 1.28097 9.99999C1.1127 10.0006 0.945962 9.9711 0.790368 9.91317C0.634774 9.85524 0.493406 9.77003 0.374419 9.66246C0.255433 9.55489 0.161182 9.42709 0.097104 9.28642C0.0330256 9.14575 0.000387576 8.99501 0.00107276 8.84288C0.00175794 8.69075 0.0357526 8.54026 0.101096 8.40007C0.166439 8.25988 0.261838 8.13277 0.38179 8.02608L3.31153 5.00096L0.380728 1.97392C0.260776 1.86723 0.165377 1.74012 0.100034 1.59993C0.0346904 1.45974 0.000695752 1.30925 1.05685e-05 1.15712C-0.000674615 1.00499 0.0319635 0.854247 0.0960419 0.71358C0.16012 0.572914 0.254371 0.445109 0.373357 0.337538C0.492344 0.229967 0.633711 0.144758 0.789306 0.0868277C0.9449 0.0288969 1.11164 -0.000609893 1.27991 9.55452e-06C1.44818 0.000629002 1.61465 0.0313623 1.76972 0.0904366C1.92479 0.149511 2.06538 0.235758 2.1834 0.344201L5.00053 3.25504L7.8166 0.344201C7.93462 0.235758 8.07521 0.149511 8.23028 0.0904366C8.38535 0.0313623 8.55182 0.000629002 8.72009 9.55452e-06C8.88836 -0.000609893 9.0551 0.0288969 9.21069 0.0868277C9.36629 0.144758 9.50766 0.229967 9.62664 0.337538C9.74563 0.445109 9.83988 0.572914 9.90396 0.71358C9.96804 0.854247 10.0007 1.00499 9.99999 1.15712C9.9993 1.30925 9.96531 1.45974 9.89997 1.59993C9.83462 1.74012 9.73922 1.86723 9.61927 1.97392L6.68954 5.00096L9.61927 8.02608C9.73779 8.13311 9.83181 8.26021 9.89596 8.40011C9.96011 8.54001 9.99313 8.68997 9.99313 8.84142C9.99313 8.99287 9.96011 9.14283 9.89596 9.28273C9.83181 9.42263 9.73779 9.54973 9.61927 9.65676Z"
                    fill="black"
                    fill-opacity="0.35"
                  />
                </svg>
              </button> */}
                {modals.tpsDeleted &&
                  createPortal(
                    <DialogBox>
                      <PopUp
                        title="A third party seller has been removed"
                        main="Luke elliot has been removed from your team"
                        body="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eget utvest-ibulum bibendum egestas. Enim mi arcu convallis enim purus interdum. Ut neque at adipiscing tortor facilisis sagittis libero. Ac bibendum vel blandit."
                        button="Back to Users"
                        onClose={() =>
                          setModals((prevState) => ({
                            ...prevState,
                            tpsDeleted: false
                          }))
                        }
                        onClick={() =>
                          setModals((prevState) => ({
                            ...prevState,
                            tpsDeleted: false
                          }))
                        }
                      />
                    </DialogBox>,
                    document.body
                  )}
              </RouterLink>
            )
          );

        default:
          return null;
      }
    });
  }, [userType, users, modals]);

  async function handleAddUser(e) {
    e.preventDefault();
    setModals((prevState) => ({ ...prevState, addUserLoader: true }));
    const { response } = await addUser(typeOfUser, userSelected);
    if (response.status === "success") {
      setModals((prevState) => ({
        ...prevState,
        newUserAddSuccessfully: true,
        addUserLoader: false,
        searchUser: false
      }));
      setUserArr([]);
      setUserSelected(null);
      setSearchUserString("");
      individualUsers();
      organisations();
      thirdPartySeller();
    } else {
      setModals((prevState) => ({ ...prevState, addUserLoader: false }));
      notify(response?.message ? response?.message : "Something went wrong");
    }
  }

  async function handleUserSearch(e) {
    e && e.preventDefault();
    setModals((prevState) => ({ ...prevState, searchUserLoader: true }));
    const { response } = await searchUser(typeOfUser, searchUserString);
    if (response.status === "success") {
      setUserArr(
        typeOfUser === 0
          ? response.data.customers
          : typeOfUser === 1
          ? response.data.organisations
          : response.data.thirdParties
      );
    } else {
      notify(
        response?.message ? response?.message : "Something went wrong go figure"
      );
    }
    setModals((prevState) => ({ ...prevState, searchUserLoader: false }));
  }

  // useMemo(() => {
  //   console.log("working");
  //   searchUserString !== "" && handleUserSearch();
  // }, [searchUserString]);

  async function handleNewIndiviual(data) {
    console.log(data, "indiviual data");
    const { response, error } = await createIndiviualUser({
      fullName: data.name,
      mobile: data.phone_number,
      email: data.email
    });
    if (response.status === "success") {
      reset();
      setModals((prev) => ({
        ...prev,
        stepperOrg: false,
        individualCreated: true
      }));
    } else {
      notify(
        response?.message ? response?.message : "Something went wrong go figure"
      );
    }
  }

  const onTabClick = (tab) => {
    if (tab == "Individual User") {
      setUserType(0);
    } else if (tab == "Organisations") {
      setUserType(1);
    }
  };

  useEffect(()=>{
if(search!=undefined){
  individualUsers()
  organisations()
}
  },[search])

  return (
    <div className="box-border min-h-screen flex">
      <Sidebar active="users" />
      <div
        className={`${currentStep === 2 && modals.stepperOrg && "h-[1022px]"} ${
          currentStep === 3 && modals.stepperOrg && "h-[868px]"
        } relative lg:w-top lg:border-r-24 border-r-primary-dark sm:px-8 lg:px-12 pt-8 border-r-solid lg:border-t-24 border-t-primary-dark border-t-solid`}
      >
        <Navbar from='Users' />
        <h1 className="hidden text-h1 lg:flex items-center text-heading text-left font-semibold">
          {" "}
          {orderHistory && (
            <button onClick={() => setOrderHistory(false)}>
              <svg
                width="29"
                height="27"
                viewBox="0 0 29 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.7113 21.3745C16.5308 21.375 16.3525 21.3379 16.1894 21.2659C16.0263 21.1939 15.8826 21.0887 15.7688 20.9582L9.9326 14.2082C9.75487 14.0069 9.65771 13.7544 9.65771 13.4938C9.65771 13.2333 9.75487 12.9808 9.9326 12.7795L15.9743 6.02946C16.1794 5.79971 16.4741 5.65523 16.7936 5.62781C17.1131 5.60038 17.4313 5.69225 17.678 5.88321C17.9248 6.07416 18.08 6.34856 18.1094 6.64604C18.1389 6.94352 18.0402 7.23971 17.8351 7.46946L12.4338 13.4995L17.6538 19.5295C17.8016 19.6946 17.8955 19.8957 17.9243 20.1089C17.9532 20.3222 17.9158 20.5386 17.8167 20.7327C17.7175 20.9268 17.5607 21.0904 17.3648 21.2041C17.169 21.3179 16.9422 21.377 16.7113 21.3745Z"
                  fill="#494949"
                />
              </svg>
            </button>
          )}{" "}
          Users
        </h1>
        <div
          className={`block lg:hidden px-4 flex lg:hidden justify-between items-center w-screen `}
        >
          <h1 className=" flex items-center text-mobile-h1  lg:text-h1 text-tertiary-dark lg:text-heading text-left font-bold lg:font-semibold">
            <span onClick={() => navigate(-1)} className=" mr-3">
              <svg
                width="12"
                height="20"
                viewBox="0 0 12 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.0491 2.5473L9.4174 0.924805L0.351562 9.9998L9.42656 19.0748L11.0491 17.4523L3.59656 9.9998L11.0491 2.5473Z"
                  fill="#702963"
                />
              </svg>
            </span>
            Users
          </h1>
          <div className="flex lg:hidden items-center">
            <button className="mr-5">
              <svg
                width="27"
                height="27"
                viewBox="0 0 27 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25.25 25.25L19.5104 19.5104M22.6111 12.0556C22.6111 17.8852 17.8852 22.6111 12.0556 22.6111C6.22588 22.6111 1.5 17.8852 1.5 12.0556C1.5 6.22588 6.22588 1.5 12.0556 1.5C17.8852 1.5 22.6111 6.22588 22.6111 12.0556Z"
                  stroke="#702963"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <button>
              <svg
                width="28"
                height="24"
                viewBox="0 0 28 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25.715 10.285H25.742C26.207 10.285 26.627 10.477 26.927 10.787C27.237 11.088 27.429 11.508 27.429 11.973V12.001V12.027C27.429 12.492 27.237 12.912 26.927 13.212C26.626 13.522 26.206 13.714 25.741 13.714H25.713H25.513L23.972 22.583C23.9068 22.9816 23.698 23.3426 23.385 23.598L23.382 23.6C23.092 23.849 22.712 24.001 22.297 24.001H5.13C4.715 24.001 4.335 23.849 4.043 23.598L4.045 23.6C3.73304 23.3466 3.52402 22.9883 3.457 22.592L3.456 22.582L1.915 13.713H1.687C1.222 13.713 0.802001 13.521 0.502001 13.211C0.342948 13.0572 0.216523 12.8729 0.130273 12.6691C0.044023 12.4653 -0.000282597 12.2463 1.35628e-06 12.025V11.997V11.971C1.35628e-06 11.506 0.192001 11.086 0.502001 10.786C0.803001 10.476 1.223 10.284 1.688 10.284H1.716H1.715L25.715 10.285ZM6.492 20.999C6.6042 20.9913 6.71365 20.9608 6.81357 20.9092C6.9135 20.8576 7.00179 20.786 7.073 20.699L7.074 20.698C7.14997 20.6136 7.20767 20.5145 7.24346 20.4068C7.27926 20.299 7.29238 20.185 7.282 20.072V20.075L6.853 14.503C6.84535 14.3908 6.81478 14.2814 6.76318 14.1814C6.71158 14.0815 6.64005 13.9932 6.553 13.922L6.552 13.921C6.46765 13.845 6.36848 13.7873 6.26075 13.7515C6.15302 13.7157 6.03905 13.7026 5.926 13.713H5.929C5.8168 13.7207 5.70736 13.7512 5.60743 13.8028C5.5075 13.8544 5.41921 13.926 5.348 14.013L5.347 14.014C5.27103 14.0984 5.21333 14.1975 5.17754 14.3052C5.14174 14.413 5.12862 14.527 5.139 14.64V14.637L5.568 20.209C5.58227 20.425 5.68064 20.6267 5.842 20.771L5.843 20.772C5.99738 20.9185 6.20215 21.0002 6.415 21H6.426H6.425L6.492 20.999ZM11.997 20.143V14.571V14.563C11.9973 14.4519 11.975 14.3419 11.9313 14.2398C11.8876 14.1377 11.8235 14.0455 11.743 13.969C11.6662 13.8885 11.5739 13.8245 11.4716 13.7808C11.3693 13.7372 11.2592 13.7148 11.148 13.715H11.132C11.0209 13.7147 10.9109 13.737 10.8088 13.7807C10.7067 13.8244 10.6145 13.8885 10.538 13.969C10.4575 14.0458 10.3935 14.1381 10.3498 14.2404C10.3062 14.3427 10.2838 14.4528 10.284 14.564V20.152C10.284 20.386 10.381 20.597 10.538 20.746C10.6148 20.8265 10.7071 20.8905 10.8094 20.9342C10.9117 20.9778 11.0218 21.0002 11.133 21H11.149C11.2601 21.0003 11.3701 20.978 11.4722 20.9343C11.5743 20.8906 11.6665 20.8265 11.743 20.746C11.8246 20.6692 11.8895 20.5766 11.9339 20.4737C11.9783 20.3709 12.0011 20.26 12.001 20.148V20.142L11.997 20.143ZM17.14 20.143V14.571V14.563C17.1403 14.4519 17.118 14.3419 17.0743 14.2398C17.0306 14.1377 16.9665 14.0455 16.886 13.969C16.8092 13.8885 16.7169 13.8245 16.6146 13.7808C16.5123 13.7372 16.4022 13.7148 16.291 13.715H16.275C16.1639 13.7147 16.0539 13.737 15.9518 13.7807C15.8497 13.8244 15.7575 13.8885 15.681 13.969C15.6005 14.0458 15.5365 14.1381 15.4928 14.2404C15.4492 14.3427 15.4268 14.4528 15.427 14.564V20.152C15.427 20.386 15.524 20.597 15.681 20.746C15.7578 20.8265 15.8501 20.8905 15.9524 20.9342C16.0547 20.9778 16.1648 21.0002 16.276 21H16.292C16.4031 21.0003 16.5131 20.978 16.6152 20.9343C16.7173 20.8906 16.8095 20.8265 16.886 20.746C16.9676 20.6692 17.0325 20.5766 17.0769 20.4737C17.1213 20.3709 17.1441 20.26 17.144 20.148V20.142L17.14 20.143ZM21.854 20.209L22.283 14.637C22.2927 14.5243 22.2792 14.4108 22.2435 14.3035C22.2077 14.1962 22.1504 14.0973 22.075 14.013L22.076 14.014C22.005 13.9268 21.9169 13.8551 21.8172 13.8032C21.7174 13.7512 21.6081 13.7202 21.496 13.712H21.493C21.3803 13.7023 21.2668 13.7158 21.1595 13.7515C21.0522 13.7873 20.9534 13.8446 20.869 13.92L20.87 13.919C20.7828 13.99 20.7111 14.0781 20.6592 14.1778C20.6072 14.2776 20.5762 14.3869 20.568 14.499V14.502L20.139 20.074C20.1293 20.1867 20.1428 20.3002 20.1786 20.4075C20.2143 20.5148 20.2716 20.6137 20.347 20.698L20.346 20.697C20.417 20.7842 20.5051 20.8559 20.6048 20.9078C20.7046 20.9598 20.8139 20.9908 20.926 20.999H21.006C21.2191 20.999 21.4241 20.9174 21.579 20.771C21.7424 20.6269 21.8426 20.4243 21.858 20.207V20.204L21.854 20.209ZM6.376 3.909L5.131 9.427H3.363L4.715 3.521C4.878 2.736 5.305 2.071 5.897 1.606L5.904 1.601C6.49976 1.11788 7.24397 0.85509 8.011 0.857001H8.049H8.047H10.283V0.849001C10.283 0.615001 10.38 0.404001 10.537 0.255001C10.6138 0.174269 10.7063 0.110026 10.8088 0.0661855C10.9112 0.0223455 11.0216 -0.000173409 11.133 1.00545e-06H16.295C16.529 1.00545e-06 16.74 0.097001 16.889 0.254001C16.9695 0.330769 17.0335 0.423105 17.0772 0.525393C17.1208 0.627681 17.1432 0.737783 17.143 0.849001V0.857001H19.416C20.217 0.857001 20.952 1.137 21.528 1.605L21.522 1.6C22.1286 2.07342 22.5483 2.74605 22.707 3.499L22.711 3.52L24.063 9.426H22.295L21.05 3.908C20.9595 3.52933 20.7465 3.19115 20.444 2.946L20.441 2.943C20.1467 2.69994 19.7767 2.56731 19.395 2.568H17.14V2.576C17.1403 2.68709 17.118 2.79707 17.0743 2.89921C17.0306 3.00135 16.9665 3.09349 16.886 3.17C16.8092 3.25048 16.7169 3.31449 16.6146 3.35816C16.5123 3.40183 16.4022 3.42423 16.291 3.424H11.133C11.0219 3.42432 10.9119 3.40196 10.8098 3.35829C10.7077 3.31461 10.6155 3.25054 10.539 3.17C10.4585 3.09323 10.3945 3.0009 10.3508 2.89861C10.3072 2.79632 10.2848 2.68622 10.285 2.575V2.567H8.03C7.64739 2.56657 7.27666 2.69993 6.982 2.944L6.985 2.942C6.68473 3.18519 6.47283 3.52043 6.382 3.896L6.38 3.908L6.376 3.909Z"
                  fill="#702963"
                />
              </svg>
            </button>
          </div>
        </div>
        <OrderHistoryHeader
          onClick={onTabClick}
          right={
            <button
              onClick={() =>
                setModals((prevState) => ({ ...prevState, addNew: true }))
              }
              className="font-semibold text-h5 text-tertiary-dark underline"
            >
              Add a New User
            </button>
          }
        />

        {/* <div className="hidden lg:flex items-center justify-between">
          <div className="w-[450px] mt-6 flex pb-4 border-b-1 border-solid border-[#c5c1c4]">
            <button
              onClick={() => setUserType(0)}
              className={`text-secondary-dark transition-[border] duration-100 tracking-wide mr-[60px] outline-0 border-0 text-montserrat font-semibold text-[18px] px-2 ${userType === 0 &&
                "text-tertiary-dark border-b-[1.1px] border-b-solid border-b-primary-dark"
                }`}
            >
              Individual User
            </button>
            <button
              onClick={() => setUserType(1)}
              className={`text-secondary-dark transition-[border] duration-100 tracking-wide mr-[60px] outline-0 border-0 text-montserrat font-semibold text-[18px] px-2 ${userType === 1 &&
                "text-tertiary-dark border-b-[1.1px] border-b-solid border-b-primary-dark"
                }`}
            >
              Organisations
            </button>
            
          </div>
          <button
            onClick={() =>
              setModals((prevState) => ({ ...prevState, addNew: true }))
            }
            className="font-semibold text-h5 text-tertiary-dark underline"
          >
            Add a New User
          </button>
        </div> */}
        <div className={`hidden py-10 lg:flex flex-wrap gap-[22px]`}>
          {renderedUserType}
        </div>
        <div className=" lg:hidden px-4 py-8">
          <p className=" font-bold text-[17px] ">
            Select users from given categories.
          </p>
        </div>
        <div className="lg:hidden px-4">
          <button
            onClick={() => navigate(ROUTES.INDIVIDUAL_USERS)}
            className="w-full mb-10 bg-primary-white text-tertiary-dark border-1 border-solid border-[#e7e7e7] py-3 focus:bg-primary-dark focus:text-primary-white font-bold text-[17px] leading-[22px]"
          >
            Individual Users
          </button>
          <button
            onClick={() => navigate(ROUTES.ORGANISATIONS)}
            className="w-full mb-10 bg-primary-white text-tertiary-dark border-1 border-solid border-[#e7e7e7] py-3  focus:bg-primary-dark focus:text-primary-white font-bold text-[17px] leading-[22px]"
          >
            Organisations
          </button>
          {/* <button
            onClick={() => navigate(ROUTES.THIRD_PARTY_SELLERS)}
            className="w-full mb-10 bg-primary-white mb-[80px] text-tertiary-dark border-1 border-solid border-[#e7e7e7] py-3  focus:bg-primary-dark focus:text-primary-white font-bold text-[17px] leading-[22px]"
          >
            Third Party Sellers
          </button> */}
        </div>
        <DialogBox show={modals.addNew}>
          <div className={` bg-primary-white flex flex-col  relative  p-8`}>
            <h4 className="text-h4 text-tertiary-dark font-bold mb-4">
              Add a New User
            </h4>
            <p className="text-secondary-light mb-[26px] w-[463px]">
              Select a User Type
            </p>

            <div className="flex items-center mb-2">
              <input
                id="ind"
                type="radio"
                checked={typeOfUser === 0}
                onChange={() => setTypeOfUser(0)}
                name="organization"
                className="hidden"
              />
              <div
                className={`${
                  typeOfUser === 0 ? "bg-primary-dark" : "bg-neutral-50"
                } w-[14px] h-[14px] rounded-full`}
              ></div>
              <label
                htmlFor="ind"
                className="font-semibold text-heading text-h5 ml-3"
              >
                Individual user
              </label>
            </div>

            <div className="flex items-center mb-2">
              <input
                id="org"
                type="radio"
                checked={typeOfUser === 1}
                onChange={() => setTypeOfUser(1)}
                name="organization"
                className="hidden"
              />
              <div
                className={`${
                  typeOfUser === 1 ? "bg-primary-dark" : "bg-neutral-50"
                } w-[14px] h-[14px] rounded-full`}
              ></div>
              <label
                htmlFor="org"
                className="font-semibold text-heading text-h5 ml-3"
              >
                Organization
              </label>
            </div>
            {/* <div className="flex items-center mb-[22px]">
              <input
                checked={typeOfUser === 2}
                onChange={() => setTypeOfUser(2)}
                id="tps"
                type="radio"
                name="tps"
                className="hidden"
              />
              <div
                className={`${typeOfUser === 2 ? "bg-primary-dark" : "bg-neutral-50"
                  } w-[14px] h-[14px] rounded-full`}
              ></div>
              <label
                htmlFor="tps"
                className="font-semibold text-heading text-h5 ml-3"
              >
                Third Party Seller
              </label>
            </div> */}
            <div className="text-center lg:text-right">
              <button
                onClick={() => {
                  setModals((prevState) => ({
                    ...prevState,
                    addNew: false,
                    searchUser: true
                  }));
                  // setRenderedStep(true);
                  // setCurrentStep(1);
                }}
                className="w-full max-w-[372px] lg:w-[150px] h-[56px] bg-primary-dark text-primary-white text-mobile-h5 lg:text-h5"
              >
                Next
              </button>
            </div>
            <button
              onClick={() =>
                setModals((prevState) => ({ ...prevState, addNew: false }))
              }
              className="absolute top-8 right-8"
            >
              <svg
                width="12"
                height="14"
                viewBox="0 0 12 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.2176 12.8188C10.9475 13.0888 10.5813 13.2405 10.1994 13.2405C9.81747 13.2405 9.45122 13.0888 9.18117 12.8188L5.99997 9.18281L2.81877 12.8176C2.68545 12.9531 2.52663 13.0609 2.35145 13.1347C2.17628 13.2085 1.98823 13.2469 1.79814 13.2477C1.60805 13.2485 1.41969 13.2116 1.24392 13.1392C1.06815 13.0668 0.908454 12.9604 0.77404 12.8259C0.639626 12.6915 0.533155 12.5318 0.460769 12.3561C0.388382 12.1803 0.351512 11.9919 0.352286 11.8018C0.35306 11.6118 0.391462 11.4237 0.465278 11.2485C0.539094 11.0734 0.646862 10.9145 0.782367 10.7812L4.09197 7.00121L0.781167 3.21881C0.645662 3.0855 0.537894 2.92667 0.464078 2.7515C0.390263 2.57633 0.35186 2.38827 0.351086 2.19818C0.350312 2.00809 0.387182 1.81973 0.459569 1.64397C0.531955 1.4682 0.638426 1.3085 0.77284 1.17409C0.907255 1.03967 1.06695 0.933201 1.24272 0.860814C1.41849 0.788427 1.60685 0.751557 1.79694 0.752331C1.98703 0.753105 2.17508 0.791508 2.35025 0.865323C2.52543 0.939139 2.68425 1.04691 2.81757 1.18241L5.99997 4.81961L9.18117 1.18241C9.31448 1.04691 9.47331 0.939139 9.64848 0.865323C9.82365 0.791508 10.0117 0.753105 10.2018 0.752331C10.3919 0.751557 10.5802 0.788427 10.756 0.860814C10.9318 0.933201 11.0915 1.03967 11.2259 1.17409C11.3603 1.3085 11.4668 1.4682 11.5392 1.64397C11.6116 1.81973 11.6484 2.00809 11.6476 2.19818C11.6469 2.38827 11.6085 2.57633 11.5347 2.7515C11.4608 2.92667 11.3531 3.0855 11.2176 3.21881L7.90797 7.00121L11.2176 10.7812C11.3515 10.915 11.4577 11.0738 11.5301 11.2486C11.6026 11.4234 11.6399 11.6108 11.6399 11.8C11.6399 11.9893 11.6026 12.1766 11.5301 12.3514C11.4577 12.5263 11.3515 12.6851 11.2176 12.8188Z"
                  fill="black"
                  fillOpacity="0.53"
                />
              </svg>
            </button>
          </div>
        </DialogBox>
        {/* stepperOrg starts here */}
        {modals.stepperOrg && (
          <div
            className={`w-[calc(100vw-17px)] min-h-screen bg-pop-up ${
              currentStep === 1
                ? "fixed  py-0 -top-[0px] -left-[0px]"
                : "absolute py-12 -top-[22px] -left-[116px]"
            } flex justify-center items-end md:items-center`}
          >
            <div className="w-[535px]  bg-primary-white flex flex-col  relative  p-8">
              <h4 className="text-[19px] text-tertiary-dark font-[700] mb-0">
                Add{" "}
                {/* {typeOfUser === 1 ? "an organization" : "a third party user"}{typeOfUser === 0 && "a Indiviual user"} */}
                {typeOfUser === 0
                  ? "a Indiviual user"
                  : typeOfUser === 1
                  ? "an organization"
                  : "a third party user"}
              </h4>
              {typeOfUser !== 0 && (
                <div className="flex justify-between items-center w-[400px] mx-auto mt-4 mb-10">
                  <div className="relative rounded-full w-[36px] h-[36px] bg-primary-dark border-2 border-solid border-primary-light flex justify-center items-center">
                    <svg
                      width="15"
                      height="16"
                      viewBox="0 0 15 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_2264_7463)">
                        <path
                          d="M7.47653 2.15039C6.55901 2.15039 5.8422 2.51057 5.3261 3.23092C4.80999 3.95128 4.55194 4.87211 4.55194 5.99342C4.54556 7.38656 4.9661 8.49087 5.81353 9.30637C5.92185 9.4151 5.96008 9.55442 5.92822 9.72431L5.7084 10.2136C5.63831 10.3767 5.53477 10.5041 5.39778 10.5959C5.26079 10.6876 4.97247 10.8184 4.53282 10.9883C4.51371 10.9951 4.1107 11.1344 3.3238 11.4063C2.53689 11.6781 2.11796 11.8276 2.06698 11.8548C1.53176 12.0927 1.18132 12.3407 1.01566 12.5989C0.83725 13.0271 0.748047 14.111 0.748047 15.8507H14.205C14.205 14.111 14.1158 13.0271 13.9374 12.5989C13.7717 12.3407 13.4213 12.0927 12.8861 11.8548C12.8351 11.8276 12.4162 11.6781 11.6293 11.4063C10.8424 11.1344 10.4394 10.9951 10.4202 10.9883C9.9806 10.8184 9.69228 10.6876 9.55529 10.5959C9.4183 10.5041 9.31476 10.3767 9.24467 10.2136L9.02485 9.72431C8.99299 9.55442 9.03122 9.4151 9.13954 9.30637C9.98697 8.49087 10.4075 7.38656 10.4011 5.99342C10.4011 4.87211 10.1431 3.95128 9.62698 3.23092C9.11087 2.51057 8.39406 2.15039 7.47653 2.15039Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_2264_7463">
                          <rect
                            width="13.457"
                            height="15.0051"
                            fill="white"
                            transform="translate(0.748047 0.845703)"
                          />
                        </clipPath>
                      </defs>
                    </svg>

                    <p className="text-heading whitespace-nowrap font-semibold text-p1 absolute -bottom-8 -left-5">
                      Your Profile
                    </p>
                  </div>
                  <div
                    style={{
                      background:
                        currentStep === 1
                          ? "linear-gradient(90deg, #702963, #fff)"
                          : currentStep > 1
                          ? "#702963"
                          : "#c2c2bd"
                    }}
                    className="w-[calc(50%-54px)] h-1 bg-primary-dark"
                  ></div>
                  <div
                    className={`relative rounded-full w-[36px] h-[36px] ${
                      currentStep > 1 ? "bg-primary-dark" : "bg-[#c2c2bd]"
                    } border-2 border-solid border-primary-light flex justify-center items-center`}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_2264_7468)">
                        <path
                          d="M9.58857 10.6925C9.58857 10.9516 9.37824 11.1614 9.11857 11.1614H6.29854C6.03886 11.1614 5.82853 10.9516 5.82853 10.6925V9.28577H0.188477V13.506C0.188477 14.2562 0.846483 14.9127 1.59849 14.9127H13.8186C14.5706 14.9127 15.2286 14.2562 15.2286 13.506V9.28577H9.58857V10.6925ZM13.8186 4.59667H11.4686V3.18993C11.4686 2.43968 10.8106 1.7832 10.0586 1.7832H5.35853C4.60652 1.7832 3.94851 2.43968 3.94851 3.18993V4.59667H1.59849C0.846483 4.59667 0.188477 5.25314 0.188477 6.0034V8.34795H15.2286V6.0034C15.2286 5.25314 14.5706 4.59667 13.8186 4.59667ZM9.58857 4.59667H5.82853V3.65884H9.58857V4.59667Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_2264_7468">
                          <rect
                            width="15.0401"
                            height="15.0051"
                            fill="white"
                            transform="translate(0.188477 0.845703)"
                          />
                        </clipPath>
                      </defs>
                    </svg>

                    <p className="text-heading whitespace-nowrap font-semibold text-p1 absolute -bottom-8 -left-14 w-28">
                      Business information
                    </p>
                  </div>
                  <div
                    style={{
                      background:
                        currentStep === 2
                          ? "linear-gradient(90deg, #702963, #fff)"
                          : currentStep > 2
                          ? "#702963"
                          : "#c2c2bd"
                    }}
                    className="w-[calc(50%-54px)] h-1 bg-primary-dark"
                  ></div>
                  <div
                    className={`relative rounded-full w-[36px] h-[36px] ${
                      currentStep > 2 ? "bg-primary-dark" : "bg-[#c2c2bd]"
                    } border-2 border-solid border-primary-light flex justify-center items-center`}
                  >
                    <svg
                      width="17"
                      height="16"
                      viewBox="0 0 17 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 8C0 5.87827 0.895533 3.84344 2.48959 2.34315C4.08365 0.842855 6.24566 0 8.5 0C10.7543 0 12.9163 0.842855 14.5104 2.34315C16.1045 3.84344 17 5.87827 17 8C17 10.1217 16.1045 12.1566 14.5104 13.6569C12.9163 15.1571 10.7543 16 8.5 16C6.24566 16 4.08365 15.1571 2.48959 13.6569C0.895533 12.1566 0 10.1217 0 8H0ZM8.01493 11.424L12.9087 5.66613L12.0247 5.00053L7.85173 9.90827L4.896 7.5904L4.17067 8.4096L8.01493 11.4251V11.424Z"
                        fill="white"
                      />
                    </svg>

                    <p className="text-heading whitespace-nowrap font-semibold text-p1 absolute -bottom-8 -left-7">
                      Confirmation
                    </p>
                  </div>
                </div>
              )}
              {renderedStep && typeOfUser == 0 && (
                <form onSubmit={handleSubmit(handleNewIndiviual)}>
                  <p className="font-semibold font-montserrat text-[15px] text-left text-heading-false mt-2 mb-4">
                    Enter details for the new user
                  </p>
                  <div className="flex flex-col">
                    <label className="text-p1 font-semibold text-secondary-dark -mb-2">
                      Name<span className="text-tertiary-dark">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Enter name"
                      autocomplete="off"
                      className="pl-2 mt-4 mb-4 outline-primary-light font-semibold w-[255px] h-12 bg-primary-white border-1 border-primary-light border-solid"
                      {...register("name", {
                        required: true,
                        maxLength: 80
                      })}
                    />
                    <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[-17px] text-[13px] text-[red]">
                      {errors.name && "Please enter Your Full Name !"}
                    </p>
                    <label className="text-p1 font-semibold text-secondary-dark -mb-2">
                      Mobile number
                      <span className="text-tertiary-dark">*</span>
                    </label>
                    <input
                      type="tel"
                      name="phone_number"
                      placeholder="Enter phone number"
                      autocomplete="off"
                      className="pl-2 mt-4 mb-4 outline-primary-light font-semibold w-[255px] h-12 bg-primary-white border-1 border-primary-light border-solid"
                      {...register("phone_number", {
                        required: true,
                        minLength: 10,
                        maxLength: 10
                      })}
                    />
                    <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[-17px] text-[13px] text-[red]">
                      {errors.phone_number &&
                        "Please enter Valid Mobile Number !"}
                    </p>
                    <label className="text-p1 font-semibold text-secondary-dark -mb-2">
                      Email address
                      <span className="text-tertiary-dark">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      placeholder="Enter email address"
                      autocomplete="off"
                      className="pl-2 mt-4 mb-4 outline-primary-light font-semibold w-[255px] h-12 bg-primary-white border-1 border-primary-light border-solid"
                      {...register("email", {
                        required: true,
                        pattern: /^\S+@\S+$/i
                      })}
                    />
                    <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[-17px] text-[13px] text-[red]">
                      {errors.email && "Please enter Valid Email !"}
                    </p>
                    {/* <div className="relative">
                      <label
                        className="text-p1 font-semibold text-secondary-dark -mb-2 "
                        htmlFor="password"
                      >
                        Password<span className="text-tertiary-dark">*</span>
                      </label>
                      <input
                        id="password"
                        className="pl-2 block mt-4 mb-4 outline-primary-light font-semibold w-[255px] h-12 bg-primary-white border-1 border-primary-light border-solid"
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter Password"
                        name="password"
                        {...register("password", {
                          required: true,
                          minLength: 8,
                          maxLength: 16,
                          pattern:
                            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
                        })}
                      />
                      <button
                        className="absolute  right-[14rem] top-[57px]"
                        onClick={(e) => {
                          e.preventDefault();
                          setShowPassword((prevState) => !prevState);
                        }}
                      >
                        {showPassword ? (
                          <span data-tip="Hide Password">
                            <svg
                              width="27"
                              height="12"
                              viewBox="0 0 27 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17.5465 5.99788C17.5465 7.58673 15.7315 8.87475 13.4927 8.87475C11.2538 8.87475 9.43889 7.58673 9.43889 5.99788C9.43889 4.40901 11.2538 3.12101 13.4927 3.12101C15.7315 3.121 17.5465 4.40903 17.5465 5.99788ZM13.5 0.0078125C11.1819 0.0154292 8.77919 0.433446 6.50466 1.23376C4.81586 1.85246 3.17003 2.72536 1.74137 3.80278C1.03968 4.35276 0.144698 5.14913 0 5.99881C0.0171 6.73483 1.08292 7.6433 1.74137 8.19486C3.08108 9.22996 4.68405 10.0785 6.50466 10.7645C8.62576 11.527 10.9735 11.966 13.5 11.9905C15.8203 11.9827 18.2225 11.5599 20.4945 10.7645C22.1833 10.1458 23.83 9.27228 25.2586 8.19486C25.9603 7.64488 26.8553 6.8485 27 5.99881C26.9829 5.2628 25.9171 4.3543 25.2586 3.80275C23.9189 2.76765 22.3151 1.91976 20.4945 1.23373C18.3745 0.471796 16.0209 0.0357958 13.5 0.0078125ZM13.4983 1.49528C17.011 1.49528 19.8585 3.51185 19.8585 5.99946C19.8585 8.48706 17.011 10.5036 13.4983 10.5036C9.98561 10.5036 7.1381 8.48705 7.1381 5.99946C7.1381 3.51185 9.98561 1.49528 13.4983 1.49528Z"
                                fill="#ADAAAA"
                              />
                            </svg>
                          </span>
                        ) : (
                          <span data-tip="See Password">
                            <svg
                              width="27"
                              height="18"
                              viewBox="0 0 27 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M15.0689 3.55894C14.5538 3.51767 14.0305 3.49402 13.5 3.48814C11.1819 3.49575 8.77898 3.91342 6.50446 4.71374C4.81565 5.33244 3.17056 6.20589 1.74188 7.28331C1.04022 7.83331 0.144697 8.62968 0 9.47935C0.0171 10.2154 1.08344 11.1238 1.74188 11.6754C3.0816 12.7105 4.68385 13.559 6.50446 14.245C6.56633 14.2672 6.62843 14.2892 6.69067 14.3109L5.00155 16.4959L7.29666 17.5007L19.7035 1.50013L17.4943 0.5L15.0689 3.55894V3.55894ZM20.3077 4.65026L18.6218 6.81454C19.3974 7.56091 19.8578 8.48131 19.8578 9.47935C19.8578 11.967 17.011 13.9838 13.4983 13.9838C13.3465 13.9838 13.1993 13.9716 13.0501 13.9642L11.9344 15.3949C12.449 15.4357 12.9692 15.4654 13.5 15.4706C15.8202 15.4629 18.2218 15.0404 20.4939 14.245C22.1827 13.6263 23.8294 12.7528 25.2581 11.6754C25.9598 11.1254 26.8553 10.329 27 9.47935C26.9829 8.74333 25.9165 7.83486 25.2581 7.28329C23.9184 6.24819 22.3145 5.39974 20.4939 4.71371C20.4324 4.69164 20.3695 4.67179 20.3077 4.65026V4.65026ZM13.4984 4.97497C13.6524 4.97497 13.8052 4.97954 13.9565 4.98717L12.6497 6.66319C10.8156 6.93863 9.43945 8.09453 9.43945 9.47815C9.43945 9.82571 9.52587 10.1585 9.68499 10.4669C9.68517 10.4672 9.68481 10.4678 9.68499 10.4681L8.37486 12.149C7.59746 11.402 7.13889 10.4785 7.13889 9.47933C7.13891 6.99174 9.98568 4.97496 13.4984 4.97497V4.97497ZM17.3002 8.50889L14.3553 12.2882C16.1795 12.0076 17.5457 10.8569 17.5457 9.47815C17.5457 9.13691 17.4538 8.81249 17.3002 8.50889V8.50889Z"
                                fill="#ADAAAA"
                              />
                            </svg>
                          </span>
                        )}
                      </button>
                    </div>
                    {errors.password && (
                      <p
                        className={` mb-4 md:mb-6 mt-[-16px] md:mt-[-24px] text-[13px] text-[red] `}
                      >
                        {errors.password && "Password should have "}
                        <br />
                        {errors.password && "- minimum eight characters,"}
                        <br />
                        {errors.password && "- one letter,"}
                        <br />
                        {errors.password &&
                          "- one number and- one special character."}
                        <br />
                      </p>
                    )}
                    <label
                      className="text-p1 font-semibold text-secondary-dark -mb-2  "
                      htmlFor="confirm_password"
                    >
                      Confirm Password
                      <span className="text-tertiary-dark">*</span>
                    </label>
                    <input
                      id="confirm_password"
                      className="pl-2 mt-4 mb-4 outline-primary-light font-semibold w-[255px] h-12 bg-primary-white border-1 border-primary-light border-solid"
                      type="password"
                      placeholder="Enter to Confirm Password"
                      name="confirm_password"
                      {...register("confirm_password", {
                        required: true,
                        minLength: 8,
                        maxLength: 16,
                        validate: (value) => value === getValues("password"),
                      })}
                    />
                    <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[-24px] text-[13px] text-[red]">
                      {errors.confirm_password &&
                        "Confirm Password and Password don’t match!"}
                    </p> */}
                    {/* <div className="mt-[50px] md:mt-0 flex items-start justify-between">
                      <input
                        type="checkbox"
                        onChange={checkCheckBox}
                        checked={checkBox}
                        required
                        className="mt-[5px] w-[30px] h-[27px] bg-primary-dark mr-4"
                      />
                      <p className="text-justify w-[calc(100%-48px)] text-heading-false font-[500] text-[18px] leading-[24px] md:leading-[21px] mb-6">
                        I confirm that I have read and agree to the{" "}<br />
                        <RouterLink to="https://eprakashak.in/licence-agreement" target="_blank" className="text-tertiary-dark underline ">
                          License Agreement
                        </RouterLink>
                        {"  "}
                        <RouterLink to="https://eprakashak.in/terms-and-conditions" target="_blank" className="text-tertiary-dark underline ">
                          Terms of Use
                        </RouterLink>{" "}
                        and{" "}
                        <RouterLink to="https://eprakashak.in/privacy-policy" target="_blank" className="text-tertiary-dark underline ">
                          Privacy Policy
                        </RouterLink>{" "}
                      </p>
                    </div> */}
                    {/* <div class=" flex my-6 mt-12 lg:mt-0 lg:my-0 justify-center items-center relative lg:absolute lg:top-52 0 lg:right-12 w-40 h-40 rounded-full bg-neutral-10">
                        {addNewPhoto.local ? (
                          <img
                            class="w-full h-full rounded-full object-cover"
                            src={URL.createObjectURL(addNewPhoto.Photo)}
                            alt="user"
                          />
                        ) : (
                          <p
                            typeof="file"
                            className="w-10/12 text-center text-secondary-light text-p1"
                          >
                            Add a profile picture
                          </p>
                        )}

                        <label
                          for="photo"
                          onClick={() =>
                            setAddNewPhoto((prev) => ({
                              ...prev,
                              local: true,
                            }))
                          }
                          className="cursor-pointer w-[34px] h-[34px] rounded-full bg-[#ebe8e8e8] flex items-center justify-center absolute right-5 -top-1"
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M22.5 5.25L18.75 1.5L3.75 16.5L2.25 21.75L7.5 20.25L22.5 5.25ZM15.75 4.5L19.5 8.25L15.75 4.5ZM3.75 16.5L7.5 20.25L3.75 16.5Z"
                              stroke="white"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </svg>
                        </label>
                        <input
                          name="photo"
                          id="photo"
                          type="file"
                          className="hidden"
                          onChange={(e) => {
                            setAddNewPhoto((prev) => ({
                              ...prev,
                              Photo: e.target.files[0],
                            }));
                          }}
                        />
                        <button
                          type="button"
                          className="w-[34px] h-[34px] rounded-full bg-[#ebe8e8e8] flex items-center justify-center absolute -right-1 top-7"
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13.8 4.7998C13.8 4.32241 13.6104 3.86458 13.2728 3.52701C12.9352 3.18945 12.4774 2.9998 12 2.9998C11.5226 2.9998 11.0648 3.18945 10.7272 3.52701C10.3896 3.86458 10.2 4.32241 10.2 4.7998H9C9 4.00416 9.31607 3.24109 9.87868 2.67848C10.4413 2.11588 11.2044 1.7998 12 1.7998C12.7956 1.7998 13.5587 2.11588 14.1213 2.67848C14.6839 3.24109 15 4.00416 15 4.7998H20.4C20.5591 4.7998 20.7117 4.86302 20.8243 4.97554C20.9368 5.08806 21 5.24067 21 5.3998C21 5.55893 20.9368 5.71155 20.8243 5.82407C20.7117 5.93659 20.5591 5.9998 20.4 5.9998H19.7352L18.18 19.4758C18.1123 20.0607 17.8319 20.6003 17.3923 20.9919C16.9527 21.3835 16.3844 21.5999 15.7956 21.5998H8.2044C7.61562 21.5999 7.04735 21.3835 6.6077 20.9919C6.16806 20.6003 5.88771 20.0607 5.82 19.4758L4.2636 5.9998H3.6C3.45957 5.99985 3.32357 5.95064 3.21569 5.86074C3.10781 5.77084 3.03488 5.64594 3.0096 5.5078L3 5.3998C3 5.24067 3.06321 5.08806 3.17574 4.97554C3.28826 4.86302 3.44087 4.7998 3.6 4.7998H13.8ZM18.5256 5.9998H5.4732L7.0116 19.3378C7.04547 19.6303 7.18573 19.9002 7.40567 20.096C7.62562 20.2919 7.90991 20.4 8.2044 20.3998H15.7956C16.0899 20.3997 16.3739 20.2915 16.5936 20.0956C16.8133 19.8998 16.9534 19.6301 16.9872 19.3378L18.5256 5.9998ZM10.2 8.9998C10.494 8.9998 10.74 9.1858 10.7904 9.4306L10.8 9.5254V16.8754C10.8 17.1646 10.5312 17.3998 10.2 17.3998C9.906 17.3998 9.66 17.2138 9.6096 16.969L9.6 16.8742V9.5266C9.6 9.2362 9.8688 9.001 10.2 9.001V8.9998ZM13.8 8.9998C14.094 8.9998 14.34 9.1858 14.3904 9.4306L14.4 9.5254V16.8754C14.4 17.1646 14.1312 17.3998 13.8 17.3998C13.506 17.3998 13.26 17.2138 13.2096 16.969L13.2 16.8742V9.5266C13.2 9.2362 13.4688 9.001 13.8 9.001V8.9998Z"
                              fill="white"
                            ></path>
                          </svg>
                        </button>
                      </div> */}
                  </div>
                  <div className="text-center flex items-center justify-end mt-2 lg:text-right">
                    <BtnSmallWhite
                      onClick={() => {
                        setModals((prevState) => ({
                          ...prevState,
                          stepperOrg: false
                        }));
                        setCurrentStep(1);
                      }}
                    >
                      Cancel
                    </BtnSmallWhite>
                    <button
                      type="submit"
                      disabled={!isValid}
                      // onClick={() => formStepUp()}
                      className="ml-4 w-full max-w-[372px] lg:w-[150px] outline-0 h-[56px] bg-primary-dark text-primary-white text-mobile-h5 lg:text-h5"
                    >
                      Confirm
                    </button>
                  </div>
                  <button
                    type="button"
                    onClick={() => {
                      setModals((prevState) => ({
                        ...prevState,
                        stepperOrg: false
                      }));
                      setCurrentStep(1);
                      searchUser("");
                      reset();
                    }}
                    className="absolute top-8 right-8"
                  >
                    <svg
                      width="12"
                      height="14"
                      viewBox="0 0 12 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.2176 12.8188C10.9475 13.0888 10.5813 13.2405 10.1994 13.2405C9.81747 13.2405 9.45122 13.0888 9.18117 12.8188L5.99997 9.18281L2.81877 12.8176C2.68545 12.9531 2.52663 13.0609 2.35145 13.1347C2.17628 13.2085 1.98823 13.2469 1.79814 13.2477C1.60805 13.2485 1.41969 13.2116 1.24392 13.1392C1.06815 13.0668 0.908454 12.9604 0.77404 12.8259C0.639626 12.6915 0.533155 12.5318 0.460769 12.3561C0.388382 12.1803 0.351512 11.9919 0.352286 11.8018C0.35306 11.6118 0.391462 11.4237 0.465278 11.2485C0.539094 11.0734 0.646862 10.9145 0.782367 10.7812L4.09197 7.00121L0.781167 3.21881C0.645662 3.0855 0.537894 2.92667 0.464078 2.7515C0.390263 2.57633 0.35186 2.38827 0.351086 2.19818C0.350312 2.00809 0.387182 1.81973 0.459569 1.64397C0.531955 1.4682 0.638426 1.3085 0.77284 1.17409C0.907255 1.03967 1.06695 0.933201 1.24272 0.860814C1.41849 0.788427 1.60685 0.751557 1.79694 0.752331C1.98703 0.753105 2.17508 0.791508 2.35025 0.865323C2.52543 0.939139 2.68425 1.04691 2.81757 1.18241L5.99997 4.81961L9.18117 1.18241C9.31448 1.04691 9.47331 0.939139 9.64848 0.865323C9.82365 0.791508 10.0117 0.753105 10.2018 0.752331C10.3919 0.751557 10.5802 0.788427 10.756 0.860814C10.9318 0.933201 11.0915 1.03967 11.2259 1.17409C11.3603 1.3085 11.4668 1.4682 11.5392 1.64397C11.6116 1.81973 11.6484 2.00809 11.6476 2.19818C11.6469 2.38827 11.6085 2.57633 11.5347 2.7515C11.4608 2.92667 11.3531 3.0855 11.2176 3.21881L7.90797 7.00121L11.2176 10.7812C11.3515 10.915 11.4577 11.0738 11.5301 11.2486C11.6026 11.4234 11.6399 11.6108 11.6399 11.8C11.6399 11.9893 11.6026 12.1766 11.5301 12.3514C11.4577 12.5263 11.3515 12.6851 11.2176 12.8188Z"
                        fill="black"
                        fillOpacity="0.53"
                      />
                    </svg>
                  </button>
                </form>
              )}
              {renderedStep && typeOfUser !== 0 && (
                <form onSubmit={handleSubmit(handleNewOrganization)}>
                  {currentStep === 1 && (
                    <>
                      <p className="font-semibold font-montserrat text-[15px] text-left text-heading-false mt-2 mb-4">
                        Enter details for the new user
                      </p>
                      <div className="flex flex-col">
                        <label className="text-p1 font-semibold text-secondary-dark -mb-2">
                          Name<span className="text-tertiary-dark">*</span>
                        </label>
                        <input
                          type="text"
                          name="name"
                          placeholder="Enter name"
                          autocomplete="off"
                          className="pl-2 mt-4 mb-4 outline-primary-light font-semibold w-40 h-12 bg-primary-white border-1 border-primary-light border-solid"
                          {...register("name", {
                            required: true,
                            maxLength: 80
                          })}
                        />
                        <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[-17px] text-[13px] text-[red]">
                          {errors.name && "Please enter Your Full Name !"}
                        </p>
                        <label className="text-p1 font-semibold text-secondary-dark -mb-2">
                          Mobile number
                          <span className="text-tertiary-dark">*</span>
                        </label>
                        <input
                          type="tel"
                          name="phone_number"
                          placeholder="Enter phone number"
                          autocomplete="off"
                          className="pl-2 mt-4 mb-4 outline-primary-light font-semibold w-[221px] h-12 bg-primary-white border-1 border-primary-light border-solid"
                          {...register("phone_number", {
                            required: true,
                            minLength: 10,
                            maxLength: 10,
                            pattern: /^[0-9]+$/
                          })}
                        />
                        <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[-17px] text-[13px] text-[red]">
                          {errors.phone_number &&
                            "Please enter Valid Mobile Number !"}
                        </p>
                        <label className="text-p1 font-semibold text-secondary-dark -mb-2">
                          Email address
                          <span className="text-tertiary-dark">*</span>
                        </label>
                        <input
                          type="email"
                          name="email"
                          placeholder="Enter email address"
                          autocomplete="off"
                          className="pl-2 mt-4 mb-4 outline-primary-light font-semibold w-[255px] h-12 bg-primary-white border-1 border-primary-light border-solid"
                          {...register("email", {
                            required: true,
                            pattern: /^\S+@\S+$/i
                          })}
                        />
                        <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[-17px] text-[13px] text-[red]">
                          {errors.email && "Please enter Valid Email !"}
                        </p>
                        {/* <div class=" flex my-6 mt-12 lg:mt-0 lg:my-0 justify-center items-center relative lg:absolute lg:top-52 0 lg:right-12 w-40 h-40 rounded-full bg-neutral-10">
                            {addNewPhoto.local ? (
                              <img
                                class="w-full h-full rounded-full object-cover"
                                src={URL.createObjectURL(addNewPhoto.Photo)}
                                alt="user"
                              />
                            ) : (
                              <p
                                typeof="file"
                                className="w-10/12 text-center text-secondary-light text-p1"
                              >
                                Add a profile picture
                              </p>
                            )}

                            <label
                              for="photo"
                              onClick={() =>
                                setAddNewPhoto((prev) => ({
                                  ...prev,
                                  local: true,
                                }))
                              }
                              className="cursor-pointer w-[34px] h-[34px] rounded-full bg-[#ebe8e8e8] flex items-center justify-center absolute right-5 -top-1"
                            >
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M22.5 5.25L18.75 1.5L3.75 16.5L2.25 21.75L7.5 20.25L22.5 5.25ZM15.75 4.5L19.5 8.25L15.75 4.5ZM3.75 16.5L7.5 20.25L3.75 16.5Z"
                                  stroke="white"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                              </svg>
                            </label>
                            <input
                              name="photo"
                              id="photo"
                              type="file"
                              className="hidden"
                              onChange={(e) => {
                                setAddNewPhoto((prev) => ({
                                  ...prev,
                                  Photo: e.target.files[0],
                                }));
                              }}
                            />
                            <button
                              type="button"
                              className="w-[34px] h-[34px] rounded-full bg-[#ebe8e8e8] flex items-center justify-center absolute -right-1 top-7"
                            >
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M13.8 4.7998C13.8 4.32241 13.6104 3.86458 13.2728 3.52701C12.9352 3.18945 12.4774 2.9998 12 2.9998C11.5226 2.9998 11.0648 3.18945 10.7272 3.52701C10.3896 3.86458 10.2 4.32241 10.2 4.7998H9C9 4.00416 9.31607 3.24109 9.87868 2.67848C10.4413 2.11588 11.2044 1.7998 12 1.7998C12.7956 1.7998 13.5587 2.11588 14.1213 2.67848C14.6839 3.24109 15 4.00416 15 4.7998H20.4C20.5591 4.7998 20.7117 4.86302 20.8243 4.97554C20.9368 5.08806 21 5.24067 21 5.3998C21 5.55893 20.9368 5.71155 20.8243 5.82407C20.7117 5.93659 20.5591 5.9998 20.4 5.9998H19.7352L18.18 19.4758C18.1123 20.0607 17.8319 20.6003 17.3923 20.9919C16.9527 21.3835 16.3844 21.5999 15.7956 21.5998H8.2044C7.61562 21.5999 7.04735 21.3835 6.6077 20.9919C6.16806 20.6003 5.88771 20.0607 5.82 19.4758L4.2636 5.9998H3.6C3.45957 5.99985 3.32357 5.95064 3.21569 5.86074C3.10781 5.77084 3.03488 5.64594 3.0096 5.5078L3 5.3998C3 5.24067 3.06321 5.08806 3.17574 4.97554C3.28826 4.86302 3.44087 4.7998 3.6 4.7998H13.8ZM18.5256 5.9998H5.4732L7.0116 19.3378C7.04547 19.6303 7.18573 19.9002 7.40567 20.096C7.62562 20.2919 7.90991 20.4 8.2044 20.3998H15.7956C16.0899 20.3997 16.3739 20.2915 16.5936 20.0956C16.8133 19.8998 16.9534 19.6301 16.9872 19.3378L18.5256 5.9998ZM10.2 8.9998C10.494 8.9998 10.74 9.1858 10.7904 9.4306L10.8 9.5254V16.8754C10.8 17.1646 10.5312 17.3998 10.2 17.3998C9.906 17.3998 9.66 17.2138 9.6096 16.969L9.6 16.8742V9.5266C9.6 9.2362 9.8688 9.001 10.2 9.001V8.9998ZM13.8 8.9998C14.094 8.9998 14.34 9.1858 14.3904 9.4306L14.4 9.5254V16.8754C14.4 17.1646 14.1312 17.3998 13.8 17.3998C13.506 17.3998 13.26 17.2138 13.2096 16.969L13.2 16.8742V9.5266C13.2 9.2362 13.4688 9.001 13.8 9.001V8.9998Z"
                                  fill="white"
                                ></path>
                              </svg>
                            </button>
                          </div> */}
                      </div>
                    </>
                  )}
                  {currentStep === 2 && (
                    <>
                      <p className="font-semibold font-montserrat text-[15px] text-left text-heading-false mt-2 mb-4">
                        Enter the required business information
                      </p>
                      <div className="w-full  mb-2 ">
                        <label className="text-p1 font-semibold text-secondary-dark -mb-2">
                          Brand Name
                          <span className="text-tertiary-dark">*</span>
                        </label>
                        <input
                          type="text"
                          name="brand_name"
                          placeholder="Enter brand name"
                          className="block pl-2 mt-4 mb-4 outline-primary-light font-semibold w-[181px] h-12 bg-primary-white border-1 border-primary-light border-solid"
                          autocomplete="off"
                          {...register("brand_name", {
                            required: true
                          })}
                        />
                        <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[-17px] text-[13px] text-[red]">
                          {errors.brand_name &&
                            "Please Enter Your Brand Name !"}
                        </p>
                        <label className="text-p1 font-semibold text-secondary-dark -mb-2">
                          Registered Name
                          <span className="text-tertiary-dark">*</span>
                        </label>
                        <input
                          type="text"
                          name="registered_name"
                          placeholder="Enter registered name"
                          className="block pl-2 mt-4 mb-4 outline-primary-light font-semibold w-[221px] h-12 bg-primary-white border-1 border-primary-light border-solid"
                          autocomplete="off"
                          {...register("registered_name", {
                            required: true
                          })}
                        />
                        <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[-17px] text-[13px] text-[red]">
                          {errors.registered_name &&
                            "Please Enter Registered name !"}
                        </p>
                        <label className="text-p1 font-semibold text-secondary-dark -mb-2">
                          Registered address
                          <span className="text-tertiary-dark">*</span>
                        </label>
                        <input
                          type="text"
                          name="registered_address"
                          placeholder="Enter registered address"
                          className="block pl-2 mt-4 mb-4 outline-primary-light font-semibold w-[255px] h-12 bg-primary-white border-1 border-primary-light border-solid"
                          autocomplete="off"
                          {...register("registered_address", {
                            required: true
                          })}
                        />
                        <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[-17px] text-[13px] text-[red]">
                          {errors.registered_address &&
                            "Please Enter Your Address !"}
                        </p>
                        {/* <label className="text-p1 font-semibold text-secondary-dark -mb-2">
                            Domain
                            <span className="text-tertiary-dark">*</span>
                          </label>
                          <input
                            type="text"
                            name="domain"
                            placeholder="Enter domain"
                            autocomplete="off"
                            className="block pl-2 mt-4 mb-4 outline-primary-light font-semibold w-[181px] h-12 bg-primary-white border-1 border-primary-light border-solid"
                            {...register("domain", {
                              required: true,
                              // pattern:
                              //   /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/,
                            })}
                          /> */}
                        <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[-17px] text-[13px] text-[red]">
                          {errors.domain && "Please Enter Valid Domain !"}
                        </p>
                        <label className="text-p1 font-semibold text-secondary-dark -mb-2">
                          GST<span className="text-tertiary-dark">*</span>
                        </label>
                        <input
                          type="text"
                          name="gst"
                          placeholder="Enter gst"
                          autocomplete="off"
                          className="block pl-2 mt-4 mb-4 outline-primary-light font-semibold w-[221px] h-12 bg-primary-white border-1 border-primary-light border-solid"
                          {...register("gst", {
                            required: true,
                            pattern:
                              /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
                          })}
                        />
                        <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[-17px] text-[13px] text-[red]">
                          {errors.gst && "Please Enter Valid GST Number !"}
                        </p>
                        <label className="text-p1 font-semibold text-secondary-dark -mb-2">
                          Website<span className="text-tertiary-dark">*</span>
                        </label>
                        <input
                          type="text"
                          name="website"
                          required
                          placeholder="https://example"
                          autocomplete="off"
                          className="block pl-2 mt-4 mb-4 outline-primary-light font-semibold w-[255px] h-12 bg-primary-white border-1 border-primary-light border-solid"
                          {...register("website", {
                            required: true,
                            pattern: ""
                          })}
                        />
                        <p className="mb-4 md:mb-6 mt-[-17px] md:mt-[-17px] text-[13px] text-[red]">
                          {errors.website && "Please Enter Your Website Name !"}
                        </p>
                      </div>
                    </>
                  )}
                  {currentStep === 3 && (
                    <>
                      <p className="mt-2 font-semibold font-montserrat text-[18px] text-left text-heading-false mb-5">
                        Summary
                      </p>
                      <div className="w-full flex flex-wrap  mb-2 ">
                        <p className="w-full text-heading-false text-montserrat font-semibold text-left mb-4">
                          Profile details
                        </p>
                        <div className="w-1/2">
                          <label className="text-p1 font-semibold text-secondary-dark -mb-2">
                            Name<span className="text-tertiary-dark">*</span>
                          </label>
                          <p className="block my-3 text-secondary-light  font-semibold w-[181px] bg-primary-white ">
                            {newOrgData.name}
                          </p>
                        </div>
                        <div className="w-1/2">
                          <label className="text-p1 font-semibold text-secondary-dark -mb-2">
                            Mobile number
                            <span className="text-tertiary-dark">*</span>
                          </label>
                          <p className="block my-3 text-secondary-light  font-semibold w-[181px] bg-primary-white ">
                            91+ {newOrgData.phone_number}
                          </p>
                        </div>
                        <div className="w-1/2">
                          <label className="text-p1 font-semibold text-secondary-dark -mb-2">
                            Email address
                            <span className="text-tertiary-dark">*</span>
                          </label>
                          <p className="block my-3 text-secondary-light font-semibold  bg-primary-white ">
                            {newOrgData.email}
                          </p>
                        </div>

                        <p className="w-full text-heading-false font-semibold text-montserrat text-left mt-3 mb-6">
                          Business information
                        </p>
                        <div className="w-1/2">
                          <label className="text-p1 font-semibold text-secondary-dark -mb-2">
                            Brand Name
                            <span className="text-tertiary-dark">*</span>
                          </label>
                          <p className="block my-3 text-secondary-light  font-semibold w-[181px] bg-primary-white ">
                            {newOrgData.brand_name}
                          </p>
                        </div>
                        <div className="w-1/2">
                          <label className="text-p1 font-semibold text-secondary-dark -mb-2">
                            Registered Name
                            <span className="text-tertiary-dark">*</span>
                          </label>
                          <p className="block my-3 text-secondary-light  font-semibold w-[181px] bg-primary-white ">
                            {newOrgData.registered_name}
                          </p>
                        </div>
                        <div className="w-1/2">
                          <label className="text-p1 font-semibold text-secondary-dark -mb-2">
                            Registered Address
                            <span className="text-tertiary-dark">*</span>
                          </label>
                          <p className="block my-3 text-secondary-light  font-semibold w-[181px] bg-primary-white ">
                            {newOrgData.registered_address}
                          </p>
                        </div>
                        {/* <div className="w-1/2">
                            <label className="text-p1 font-semibold text-secondary-dark -mb-2">
                              Domain
                              <span className="text-tertiary-dark">*</span>
                            </label>
                            <p className="block my-3 text-secondary-light font-semibold bg-primary-white ">
                              {newOrgData.domain}
                            </p>
                          </div> */}
                        <div className="w-1/2">
                          <label className="text-p1 font-semibold text-secondary-dark -mb-2">
                            GST<span className="text-tertiary-dark">*</span>
                          </label>
                          <p className="block my-3 text-secondary-light  font-semibold bg-primary-white ">
                            {newOrgData.gst}
                          </p>
                        </div>
                        <div className="w-1/2">
                          <label className="text-p1 font-semibold text-secondary-dark -mb-2">
                            Website
                            <span className="text-tertiary-dark">*</span>
                          </label>
                          <p className="block my-3 text-secondary-light  font-semibold bg-primary-white ">
                            {newOrgData.website}
                          </p>
                        </div>
                      </div>
                    </>
                  )}
                  {currentStep === 1 ? (
                    <div className="text-center flex items-center justify-end mt-2 lg:text-right">
                      <BtnSmallWhite
                        onClick={() => {
                          setModals((prevState) => ({
                            ...prevState,
                            stepperOrg: false
                          }));
                          setCurrentStep(1);
                        }}
                      >
                        Cancel
                      </BtnSmallWhite>
                      <button
                        type="button"
                        disabled={!isValid}
                        onClick={() => formStepUp()}
                        className={`ml-4 w-full max-w-[372px] lg:w-[150px] outline-0 h-[56px]  ${
                          isValid
                            ? "bg-primary-dark"
                            : "bg-primary-light border-[2px] border-solid cursor-not-allowed border-primary-dark"
                        } text-primary-white text-mobile-h5 lg:text-h5`}
                      >
                        Next
                      </button>
                    </div>
                  ) : currentStep === 2 ? (
                    <div className="text-center flex items-center justify-end mt-2 lg:text-right">
                      <button
                        type="submit"
                        disabled={!isValid}
                        className={`ml-4 w-full max-w-[372px] lg:w-[150px] h-[56px] k ${
                          isValid
                            ? "bg-primary-dark"
                            : "bg-primary-light border-[2px] border-solid cursor-not-allowed border-primary-dark"
                        } text-primary-white text-mobile-h5 lg:text-h5`}
                      >
                        Next
                      </button>
                    </div>
                  ) : currentStep === 3 ? (
                    <div className="text-center flex items-center justify-end mt-2 lg:text-right">
                      <div>
                        {modals.manuallyCreatedLoader ? (
                          <GeneralLoader width={4} radius={10} dark={false} />
                        ) : (
                          <button
                            onClick={handleCreateNewUser}
                            type="button"
                            className="ml-4 w-full max-w-[372px] lg:w-[150px] h-[56px] bg-primary-dark text-primary-white text-mobile-h5 lg:text-h5"
                          >
                            Confirm
                          </button>
                        )}
                      </div>
                    </div>
                  ) : null}
                  <button
                    type="button"
                    onClick={() => {
                      setModals((prevState) => ({
                        ...prevState,
                        stepperOrg: false
                      }));
                      setCurrentStep(1);
                      setNewOrgData({
                        name: "",
                        phone_number: "",
                        email: "",
                        brand_name: "",
                        registered_name: "",
                        registered_address: "",
                        domain: "",
                        gst: "",
                        website: ""
                      });
                      reset();
                    }}
                    className="absolute top-8 right-8"
                  >
                    <svg
                      width="12"
                      height="14"
                      viewBox="0 0 12 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.2176 12.8188C10.9475 13.0888 10.5813 13.2405 10.1994 13.2405C9.81747 13.2405 9.45122 13.0888 9.18117 12.8188L5.99997 9.18281L2.81877 12.8176C2.68545 12.9531 2.52663 13.0609 2.35145 13.1347C2.17628 13.2085 1.98823 13.2469 1.79814 13.2477C1.60805 13.2485 1.41969 13.2116 1.24392 13.1392C1.06815 13.0668 0.908454 12.9604 0.77404 12.8259C0.639626 12.6915 0.533155 12.5318 0.460769 12.3561C0.388382 12.1803 0.351512 11.9919 0.352286 11.8018C0.35306 11.6118 0.391462 11.4237 0.465278 11.2485C0.539094 11.0734 0.646862 10.9145 0.782367 10.7812L4.09197 7.00121L0.781167 3.21881C0.645662 3.0855 0.537894 2.92667 0.464078 2.7515C0.390263 2.57633 0.35186 2.38827 0.351086 2.19818C0.350312 2.00809 0.387182 1.81973 0.459569 1.64397C0.531955 1.4682 0.638426 1.3085 0.77284 1.17409C0.907255 1.03967 1.06695 0.933201 1.24272 0.860814C1.41849 0.788427 1.60685 0.751557 1.79694 0.752331C1.98703 0.753105 2.17508 0.791508 2.35025 0.865323C2.52543 0.939139 2.68425 1.04691 2.81757 1.18241L5.99997 4.81961L9.18117 1.18241C9.31448 1.04691 9.47331 0.939139 9.64848 0.865323C9.82365 0.791508 10.0117 0.753105 10.2018 0.752331C10.3919 0.751557 10.5802 0.788427 10.756 0.860814C10.9318 0.933201 11.0915 1.03967 11.2259 1.17409C11.3603 1.3085 11.4668 1.4682 11.5392 1.64397C11.6116 1.81973 11.6484 2.00809 11.6476 2.19818C11.6469 2.38827 11.6085 2.57633 11.5347 2.7515C11.4608 2.92667 11.3531 3.0855 11.2176 3.21881L7.90797 7.00121L11.2176 10.7812C11.3515 10.915 11.4577 11.0738 11.5301 11.2486C11.6026 11.4234 11.6399 11.6108 11.6399 11.8C11.6399 11.9893 11.6026 12.1766 11.5301 12.3514C11.4577 12.5263 11.3515 12.6851 11.2176 12.8188Z"
                        fill="black"
                        fillOpacity="0.53"
                      />
                    </svg>
                  </button>
                </form>
              )}
            </div>
          </div>
        )}
      </div>

      {modals.searchUser && (
        <div
          className={`w-[calc(100vw-17px)] min-h-screen bg-pop-up ${
            currentStep === 1
              ? "fixed  py-0 -top-[0px] -left-[0px]"
              : "absolute py-12 -top-[22px] -left-[116px]"
          } flex justify-center items-end md:items-center`}
        >
          <div className="w-[535px]  bg-primary-white flex flex-col  relative  p-8">
            <h4 className="text-[19px] text-montserrat text-tertiary-dark font-[700] mb-0">
              Add{" "}
              {typeOfUser === 0
                ? "an Individual user"
                : typeOfUser === 1
                ? "a Organization"
                : "a ThirdParty"}
            </h4>
            <p className="text-[16px] leading-[24px] text-cabin w-[90%] text-justify my-4 text-[rgba(0,0,0,0.5)]">
              {typeOfUser === 0
                ? "To add an Individual User, please search for the user by their Email Id or Mobile Number"
                : typeOfUser === 1
                ? "To add an Organization, please search for the organization by their Brand/Registered Name or their GST Number."
                : "To add a Third Party, please search by their Brand/Registered Name or their GST Number."}
            </p>
            {typeOfUser === 0 && (
              <div className="mb-2 p-2 border border-[#eeeeee] flex rounded text-s text-[rgba(0,0,0,0.5)]">
                <p>{`${process.env.REACT_APP_CUSTOMER_PORTAL_DOMAIN}signup?publisher=${user.id}`}</p>
                <img
                  title="copy"
                  onClick={copyHandler}
                  src={CopyIco}
                  className="h-5 w-5 object-contain cursor-pointer"
                />
              </div>
            )}
            <form
              onSubmit={handleUserSearch}
              className="w-full h-12 border border-solid border-[#eeeeee] p-[10px] flex items-center justify-start"
            >
              <button className="mr-2">
                <svg
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17 17.5L13.1333 13.6333M15.2222 8.61111C15.2222 12.5385 12.0385 15.7222 8.11111 15.7222C4.18375 15.7222 1 12.5385 1 8.61111C1 4.68375 4.18375 1.5 8.11111 1.5C12.0385 1.5 15.2222 4.68375 15.2222 8.61111Z"
                    stroke="#702963"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <input
                value={searchUserString}
                onChange={(e) => setSearchUserString(e.target.value)}
                className="text-cabin font-semibold leading-[19px] border-0 outline-0 text-[rgba(0,0,0,0.5)] w-[90%]"
                placeholder={
                  typeOfUser === 0
                    ? "Search User by Email or Mobile Number"
                    : typeOfUser === 1
                    ? "To add an Organization, please search for the organization by their Brand/Registered Name or their GST Number."
                    : "Search Third Party by Brand/Registered Name or GST Number."
                }
              />
            </form>
            <div className="h-[370px] p-4 overflow-hidden overflow-y-scroll scrollbar scrollbar-track-[0]">
              {searchUserString === "" ? (
                <div className="flex w-full flex-col h-full justify-center items-center">
                  <span className="w-[120px] h-[120px] rounded-full bg-[rgba(210,209,209,0.25)] flex justify-center items-center">
                    <svg
                      width="67"
                      height="67"
                      viewBox="0 0 67 67"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M65.125 64.3763L50.3586 49.9581L65.125 64.3763ZM58.5416 30.6888C58.5416 37.9215 55.5938 44.8579 50.3467 49.9722C45.0996 55.0865 37.983 57.9596 30.5625 57.9596C23.1419 57.9596 16.0253 55.0865 10.7782 49.9722C5.53111 44.8579 2.58331 37.9215 2.58331 30.6888C2.58331 23.4561 5.53111 16.5197 10.7782 11.4054C16.0253 6.29114 23.1419 3.41797 30.5625 3.41797C37.983 3.41797 45.0996 6.29114 50.3467 11.4054C55.5938 16.5197 58.5416 23.4561 58.5416 30.6888V30.6888Z"
                        stroke="#B6B6B6"
                        stroke-width="5"
                        stroke-linecap="round"
                      />
                    </svg>
                  </span>
                  <p className="mt-4 mb-1 text-cabin font-medium text-[18px] leading-[24px] text-[rgba(0,0,0,0.56)] text-center">
                    Search Users
                  </p>
                  <p className="leading-[24px] text-center text-[rgba(0,0,0,0.5)] text-cabin w-2/3"></p>
                </div>
              ) : modals.searchUserLoader ? (
                <div className="flex w-full flex-col h-full justify-center items-center relatives">
                  <GeneralLoader radius={40} width={5} dark={true} />
                </div>
              ) : userArr.length === 0 ? (
                <div className="flex w-full flex-col h-full justify-center items-center">
                  <span className="w-[120px] h-[120px] rounded-full bg-[rgba(210,209,209,0.25)] flex justify-center items-center">
                    <svg
                      width="67"
                      height="67"
                      viewBox="0 0 67 67"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M65.125 64.3763L50.3586 49.9581L65.125 64.3763ZM58.5416 30.6888C58.5416 37.9215 55.5938 44.8579 50.3467 49.9722C45.0996 55.0865 37.983 57.9596 30.5625 57.9596C23.1419 57.9596 16.0253 55.0865 10.7782 49.9722C5.53111 44.8579 2.58331 37.9215 2.58331 30.6888C2.58331 23.4561 5.53111 16.5197 10.7782 11.4054C16.0253 6.29114 23.1419 3.41797 30.5625 3.41797C37.983 3.41797 45.0996 6.29114 50.3467 11.4054C55.5938 16.5197 58.5416 23.4561 58.5416 30.6888V30.6888Z"
                        stroke="#B6B6B6"
                        stroke-width="5"
                        stroke-linecap="round"
                      />
                    </svg>
                  </span>
                  <p className="mt-4 mb-1 text-cabin font-medium text-[18px] leading-[24px] text-[rgba(0,0,0,0.56)] text-center">
                    Sorry couldn't find any users
                  </p>
                  <p className="leading-[24px] text-center text-[rgba(0,0,0,0.5)] text-cabin w-2/3">
                    {typeOfUser === 0
                      ? "If User is not to be found, please Register the User on ePrakashak by clicking the following link: "
                      : typeOfUser === 1
                      ? "If Organization is not to be found, please Register them on ePrakashak by clicking the following link:"
                      : "If Third Party is not to be found, please Register them on ePrakashak by clicking the following link:"}
                  </p>

                  <button
                    onClick={() => {
                      setModals((prevState) => ({
                        ...prevState,
                        searchUser: false,
                        stepperOrg: true
                      }));

                      setRenderedStep(true);
                    }}
                    className="border-0 outline-0 underline text-tertiary-dark text-cabin text-[17px] leading-[24px] font-medium mt-2"
                  >
                    {/* {typeOfUser === 1
                        ? "Add a new organization"
                        : "Add a new third party user"}
                      {typeOfUser== 0 && "Add a new indiviual user"} */}
                    {typeOfUser === 0
                      ? "Register a new User"
                      : typeOfUser === 1
                      ? "Register a new Organization"
                      : "Register a new Third Party"}
                  </button>
                </div>
              ) : (
                <div className="flex flex-col  ">
                  {userArr.map((user) =>
                    typeOfUser === 0 ? (
                      <div
                        onClick={() => setUserSelected(user.id)}
                        className={`h-[133px] grid grid-cols-[12%_88%] box-border p-1 pb-3 border ${
                          user.id === userSelected
                            ? "border-[rgba(112,41,99)]"
                            : "border-[rgba(112,41,99,0.2)]"
                        } mb-3`}
                      >
                        <div className="col-start-1 col-end-2">
                          {user.photo ? (
                            <img
                              src={user.photo}
                              alt="user"
                              className="h-full block rounded-full"
                            />
                          ) : (
                            <div className="h-[45px] w-[43px] flex justify-center items-center bg-[#c4c4c4] rounded-full">
                              <p className="capitalize text-[#fff]">
                                {user.fullName[0]}
                              </p>
                            </div>
                          )}
                        </div>
                        <div className="col-start-2 col-end-3 flex flex-col px-2">
                          <p className="text-[#585858] text-montserrat font-semibold leading-[22px] mb-3 mt-3">
                            {user.fullName}
                          </p>
                          <div className="flex flex-col justify-between">
                            {typeOfUser !== 0 && (
                              <p className="text-cabin font-medium text-[14px] text-[#aeaeae]">
                                Brand name:{" "}
                                <span className="text-[#5f5f5f] font-semibold ml-5">
                                  {user.brandName}
                                </span>
                              </p>
                            )}
                            <p className="text-cabin font-medium text-[14px] text-[#aeaeae]">
                              Mobile number:{" "}
                              <span className="text-[#5f5f5f] font-semibold ml-1">
                                {user.mobile}
                              </span>
                            </p>
                            <p className="text-cabin font-medium text-[14px] text-[#aeaeae]">
                              Email Address:{" "}
                              <span className="text-[#5f5f5f] font-semibold ml-1">
                                {user.email}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    ) : typeOfUser === 1 ? (
                      <div
                        onClick={() => setUserSelected(user.id)}
                        className={`h-[133px] grid grid-cols-[12%_88%] box-border p-1 pb-3 border ${
                          user.id === userSelected
                            ? "border-[rgba(112,41,99)]"
                            : "border-[rgba(112,41,99,0.2)]"
                        } mb-3`}
                      >
                        <div className="col-start-1 col-end-2">
                          {user.organisationPhoto ? (
                            <img
                              src={user.organisationPhoto}
                              alt="user"
                              className="h-full block rounded-full"
                            />
                          ) : (
                            <div className="h-[45px] w-[43px] flex justify-center items-center bg-[#c4c4c4] rounded-full">
                              <p className="capitalize text-[#fff]">
                                {user.brandName[0]}
                              </p>
                            </div>
                          )}
                        </div>
                        <div className="col-start-2 col-end-3 flex flex-col px-2">
                          <p className="text-[#585858] text-montserrat font-semibold leading-[22px] mb-3 mt-3">
                            {user.registeredName}
                          </p>
                          <div className="flex flex-col justify-between">
                            {typeOfUser !== 0 && (
                              <p className="text-cabin font-medium text-[14px] text-[#aeaeae]">
                                Brand name:{" "}
                                <span className="text-[#5f5f5f] font-semibold ml-5">
                                  {user.brandName}
                                </span>
                              </p>
                            )}
                            <p className="text-cabin font-medium text-[14px] text-[#aeaeae]">
                              Mobile number:{" "}
                              <span className="text-[#5f5f5f] font-semibold ml-1">
                                {user.mobile ? user.mobile : "Not available"}
                              </span>
                            </p>
                            <p className="text-cabin font-medium text-[14px] text-[#aeaeae]">
                              Email Address:{" "}
                              <span className="text-[#5f5f5f] font-semibold ml-1">
                                {user.email ? user.email : "Not available"}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        onClick={() => setUserSelected(user.id)}
                        className={`h-[133px] grid grid-cols-[12%_88%] box-border p-1 pb-3 border ${
                          user.id === userSelected
                            ? "border-[rgba(112,41,99)]"
                            : "border-[rgba(112,41,99,0.2)]"
                        } mb-3`}
                      >
                        <div className="col-start-1 col-end-2">
                          {user.thirdPartyPhoto ? (
                            <img
                              src={user.thirdPartyPhoto}
                              alt="user"
                              className="h-full block rounded-full"
                            />
                          ) : (
                            <div className="h-[45px] w-[43px] flex justify-center items-center bg-[#c4c4c4] rounded-full">
                              <p className="capitalize text-[#fff]">
                                {user.brandName[0]}
                              </p>
                            </div>
                          )}
                        </div>
                        <div className="col-start-2 col-end-3 flex flex-col px-2">
                          <p className="text-[#585858] text-montserrat font-semibold leading-[22px] mb-3 mt-3">
                            {user.registeredName}
                          </p>
                          <div className="flex flex-col justify-between">
                            {typeOfUser !== 0 && (
                              <p className="text-cabin font-medium text-[14px] text-[#aeaeae]">
                                Brand name:{" "}
                                <span className="text-[#5f5f5f] font-semibold ml-5">
                                  {user.brandName}
                                </span>
                              </p>
                            )}
                            <p className="text-cabin font-medium text-[14px] text-[#aeaeae]">
                              Mobile number:{" "}
                              <span className="text-[#5f5f5f] font-semibold ml-1">
                                {user.mobile ? user.mobile : "Not available"}
                              </span>
                            </p>
                            <p className="text-cabin font-medium text-[14px] text-[#aeaeae]">
                              Email Address:{" "}
                              <span className="text-[#5f5f5f] font-semibold ml-1">
                                {user.email ? user.email : "Not available"}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              )}
            </div>
            <div className="flex justify-end">
              {!userSelected ? (
                <BtnSmallDisabled>Add</BtnSmallDisabled>
              ) : modals.addUserLoader ? (
                <GeneralLoader width={3} radius={15} dark={false} />
              ) : (
                <BtnSmall onClick={handleAddUser}>Add</BtnSmall>
              )}
            </div>

            <button
              type="button"
              onClick={() => {
                setModals((prevState) => ({
                  ...prevState,
                  searchUser: false
                }));
                setSearchUserString("");
                setUserArr([]);
                setUserSelected(null);
              }}
              className="absolute top-8 right-8"
            >
              <svg
                width="12"
                height="14"
                viewBox="0 0 12 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.2176 12.8188C10.9475 13.0888 10.5813 13.2405 10.1994 13.2405C9.81747 13.2405 9.45122 13.0888 9.18117 12.8188L5.99997 9.18281L2.81877 12.8176C2.68545 12.9531 2.52663 13.0609 2.35145 13.1347C2.17628 13.2085 1.98823 13.2469 1.79814 13.2477C1.60805 13.2485 1.41969 13.2116 1.24392 13.1392C1.06815 13.0668 0.908454 12.9604 0.77404 12.8259C0.639626 12.6915 0.533155 12.5318 0.460769 12.3561C0.388382 12.1803 0.351512 11.9919 0.352286 11.8018C0.35306 11.6118 0.391462 11.4237 0.465278 11.2485C0.539094 11.0734 0.646862 10.9145 0.782367 10.7812L4.09197 7.00121L0.781167 3.21881C0.645662 3.0855 0.537894 2.92667 0.464078 2.7515C0.390263 2.57633 0.35186 2.38827 0.351086 2.19818C0.350312 2.00809 0.387182 1.81973 0.459569 1.64397C0.531955 1.4682 0.638426 1.3085 0.77284 1.17409C0.907255 1.03967 1.06695 0.933201 1.24272 0.860814C1.41849 0.788427 1.60685 0.751557 1.79694 0.752331C1.98703 0.753105 2.17508 0.791508 2.35025 0.865323C2.52543 0.939139 2.68425 1.04691 2.81757 1.18241L5.99997 4.81961L9.18117 1.18241C9.31448 1.04691 9.47331 0.939139 9.64848 0.865323C9.82365 0.791508 10.0117 0.753105 10.2018 0.752331C10.3919 0.751557 10.5802 0.788427 10.756 0.860814C10.9318 0.933201 11.0915 1.03967 11.2259 1.17409C11.3603 1.3085 11.4668 1.4682 11.5392 1.64397C11.6116 1.81973 11.6484 2.00809 11.6476 2.19818C11.6469 2.38827 11.6085 2.57633 11.5347 2.7515C11.4608 2.92667 11.3531 3.0855 11.2176 3.21881L7.90797 7.00121L11.2176 10.7812C11.3515 10.915 11.4577 11.0738 11.5301 11.2486C11.6026 11.4234 11.6399 11.6108 11.6399 11.8C11.6399 11.9893 11.6026 12.1766 11.5301 12.3514C11.4577 12.5263 11.3515 12.6851 11.2176 12.8188Z"
                  fill="black"
                  fillOpacity="0.53"
                />
              </svg>
            </button>
          </div>
        </div>
      )}

      <DialogBox show={modals.newUserAddSuccessfully}>
        <PopUp
          height={true}
          title="New user has been added"
          body="A new has been added successfully"
          onClose={() =>
            setModals((prevState) => ({
              ...prevState,
              newUserAddSuccessfully: false
            }))
          }
          button="close"
          onClick={() =>
            setModals((prevState) => ({
              ...prevState,
              newUserAddSuccessfully: false
            }))
          }
        />
      </DialogBox>

      <DialogBox show={modals.createdSuccessfully}>
        <PopUp
          height={true}
          title="Created Successfully"
          onClose={() =>
            setModals((prevState) => ({
              ...prevState,
              createdSuccessfully: false
            }))
          }
          button="close"
          onClick={() =>
            setModals((prevState) => ({
              ...prevState,
              createdSuccessfully: false
            }))
          }
        />
      </DialogBox>
      <DialogBox show={modals.individualCreated}>
        <PopUp
          height={true}
          title={"New user has been added"}
          body="A New Indiviual user added successfully"
          onClose={() => {
            setModals((prevState) => ({
              ...prevState,
              individualCreated: false
            }));
            reset();
          }}
          button="close"
          onClick={() => {
            setModals((prevState) => ({
              ...prevState,
              individualCreated: false
            }));
            reset();
          }}
        />
      </DialogBox>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        closeOnClick
        pauseOnFocusLoss
        pauseOnHover
      />
    </div>
  );
}
